function tosotGetCalculatorRoot(fromNode) {
  if (fromNode && fromNode.closest) {
    var scoped = fromNode.closest('[data-tosot-calculator-root]');
    if (scoped) return scoped;
  }
  return document.querySelector('[data-tosot-calculator-root]');
}

function tosotMeasureCalculatorPanel(stage, panel) {
  var stageWidth = stage.offsetWidth || stage.getBoundingClientRect().width || modalFallbackWidth();
  var sandbox = document.createElement('div');
  sandbox.style.cssText =
    'position:absolute;left:0;top:0;width:' +
    stageWidth +
    'px;visibility:hidden;pointer-events:none;height:auto;overflow:visible;';
  var panelClone = panel.cloneNode(true);
  panelClone.removeAttribute('id');
  panelClone.classList.add('tosot-panel-active');
  panelClone.style.display = 'block';
  sandbox.appendChild(panelClone);
  stage.appendChild(sandbox);
  var height = sandbox.scrollHeight;
  stage.removeChild(sandbox);
  return Math.ceil(height);
}

function modalFallbackWidth() {
  return Math.min(880, window.innerWidth * 0.92);
}

function tosotIsCalculatorPopupMobile() {
  return window.matchMedia('(max-width: 749px)').matches;
}

function tosotGetPopupViewportBottom() {
  var bottomInset = 12;
  if (window.visualViewport) {
    bottomInset = Math.max(
      12,
      window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop + 12
    );
  }
  return window.innerHeight - bottomInset;
}

function tosotGetPopupStageAvailableHeight(modal, wrapper, contentInfo) {
  var content = modal.querySelector('.product-calculator-popup__content');
  if (!content) return Math.floor(window.innerHeight * 0.82);

  var tabBar = wrapper.querySelector('.tosot-tab-bar');
  var tabBarHeight = 0;
  if (tabBar) {
    var tabBarStyle = window.getComputedStyle(tabBar);
    tabBarHeight = tabBar.offsetHeight + parseFloat(tabBarStyle.marginBottom || 0);
  }

  var wrapperStyle = window.getComputedStyle(wrapper);
  var wrapperPad =
    parseFloat(wrapperStyle.paddingTop || 0) + parseFloat(wrapperStyle.paddingBottom || 0);

  if (!tosotIsCalculatorPopupMobile()) {
    var viewportBottom = window.innerHeight - 12;
    var contentTop = content.getBoundingClientRect().top;
    return Math.max(320, Math.floor(viewportBottom - contentTop - tabBarHeight - wrapperPad));
  }

  var viewportBottom = tosotGetPopupViewportBottom();
  var stage = wrapper.querySelector('[data-tosot-panels-stage]');
  var stageTop = stage ? stage.getBoundingClientRect().top : wrapper.getBoundingClientRect().top;

  var contentInfoPad = 0;
  if (contentInfo) {
    var contentInfoStyle = window.getComputedStyle(contentInfo);
    contentInfoPad = parseFloat(contentInfoStyle.paddingBottom || 0);
  }

  var contentStyle = window.getComputedStyle(content);
  var contentPadBottom = parseFloat(contentStyle.paddingBottom || 0);

  return Math.max(200, Math.floor(viewportBottom - stageTop - contentInfoPad - contentPadBottom));
}

function tosotPrepareCalculatorPopupRoot(contentInfo, root) {
  if (!contentInfo || !root) return;

  root.classList.add('tosot-combined-wrapper--product-popup');

  var wrapperId = contentInfo.dataset.calculatorWrapperId;
  if (wrapperId) {
    root.id = 'shopify-section-' + wrapperId;
  }

  var panelList = Array.prototype.slice.call(root.querySelectorAll('.tosot-tab-panel'));
  if (panelList.length > 1 && !root.querySelector('[data-tosot-panels-stage]')) {
    var stage = document.createElement('div');
    stage.className = 'tosot-calculator-panels-stage';
    stage.setAttribute('data-tosot-panels-stage', '');
    panelList.forEach(function (panel) {
      stage.appendChild(panel);
    });
    var tabBar = root.querySelector('.tosot-tab-bar');
    if (tabBar) {
      tabBar.insertAdjacentElement('afterend', stage);
    } else {
      root.appendChild(stage);
    }
  }

  var panels = root.querySelectorAll('.tosot-tab-panel');
  panels.forEach(function (panel) {
    panel.classList.remove('tosot-panel-active');
  });
  if (panels.length) {
    panels[0].classList.add('tosot-panel-active');
  }

  var tabs = root.querySelectorAll('.tosot-tab-btn');
  tabs.forEach(function (btn) {
    btn.classList.remove('tosot-tab-active');
    btn.setAttribute('aria-selected', 'false');
  });
  if (tabs.length) {
    tabs[0].classList.add('tosot-tab-active');
    tabs[0].setAttribute('aria-selected', 'true');
  }

  tosotUpdateCalculatorPanelSubtitle(root);
}

function tosotGetSectionHtmlFromResponse(data, contentInfo) {
  if (!data || typeof data !== 'object') return '';

  var payload = data;
  if (payload.sections && typeof payload.sections === 'object') {
    payload = payload.sections;
  }

  var sectionIdEl = contentInfo;
  if (!sectionIdEl || !sectionIdEl.getAttribute('data-calculator-section-id')) {
    sectionIdEl = document.querySelector('[data-product-calculator-popup][data-calculator-section-id]');
  }
  if (!sectionIdEl) {
    sectionIdEl = document.querySelector('[data-calculator-section-id]');
  }
  var sectionId = sectionIdEl && sectionIdEl.getAttribute('data-calculator-section-id');
  if (sectionId && payload[sectionId]) return payload[sectionId];

  var keys = Object.keys(payload);
  for (var i = 0; i < keys.length; i++) {
    var html = payload[keys[i]];
    if (
      html &&
      (html.indexOf('data-tosot-calculator-root') >= 0 ||
        html.indexOf('tosot-calculator-live-config') >= 0 ||
        html.indexOf('data-tosot-calculator-section-settings') >= 0)
    ) {
      return html;
    }
  }

  if (payload.calculator_iUU96a) return payload.calculator_iUU96a;
  if (payload.calculator_zkU8qn) return payload.calculator_zkU8qn;
  if (payload.calculator) return payload.calculator;

  return keys.length ? payload[keys[0]] : '';
}

function tosotMergeCalculatorSectionPayload(primary, secondary) {
  if (!primary) return secondary;
  if (!secondary) return primary;

  primary.notices = primary.notices || { btu: null, refrig: null };
  secondary.notices = secondary.notices || { btu: null, refrig: null };

  if (!primary.notices.btu && secondary.notices.btu) primary.notices.btu = secondary.notices.btu;
  if (!primary.notices.refrig && secondary.notices.refrig) primary.notices.refrig = secondary.notices.refrig;
  if (!primary.sectionRoot && secondary.sectionRoot) primary.sectionRoot = secondary.sectionRoot;

  return primary;
}

function tosotCalculatorPayloadHasNotices(payload) {
  return !!(payload && payload.notices && (payload.notices.btu || payload.notices.refrig));
}

function tosotNoticeHasContent(content) {
  if (content == null || content === '') return false;
  var str = String(content);
  if (!str.trim()) return false;
  var tmp = document.createElement('div');
  tmp.innerHTML = str;
  return tmp.textContent.replace(/\s/g, '').length > 0;
}

function tosotNormalizePanelNotice(notice) {
  if (!notice || !tosotNoticeHasContent(notice.content)) return null;
  return {
    title: notice.title ? String(notice.title).trim() : '',
    content: String(notice.content),
  };
}

function tosotParsePanelNoticeFromSettings(settingsEl, panelKey) {
  if (!settingsEl) return null;
  var panelEl = settingsEl.querySelector('[data-tosot-panel-notice="' + panelKey + '"]');
  if (!panelEl) return null;
  var titleEl = panelEl.querySelector('[data-tosot-notice-title]');
  var contentEl = panelEl.querySelector('[data-tosot-notice-content]');
  if (!contentEl || !contentEl.innerHTML.trim()) return null;
  return {
    title: titleEl ? titleEl.textContent.trim() : '',
    content: contentEl.innerHTML,
  };
}

function tosotParsePanelNoticeFromPanelDom(panel) {
  if (!panel) return null;
  var footer = panel.querySelector('.tosot-calc-footer-content');
  if (!footer) return null;
  var titleEl = footer.querySelector('.tosot-calc-notice-title');
  var bodyEl = footer.querySelector('.tosot-calc-notice-body');
  if (!bodyEl || !bodyEl.innerHTML.trim()) return null;
  return {
    title: titleEl ? titleEl.textContent.trim() : '',
    content: bodyEl.innerHTML,
  };
}

function tosotParseCalculatorNoticesFromLiveConfig(container) {
  if (!container) return { btu: null, refrig: null };

  var configEl = container.querySelector('#tosot-calculator-live-config');
  if (!configEl || !configEl.textContent.trim()) return { btu: null, refrig: null };

  try {
    var config = JSON.parse(configEl.textContent.trim());
    if (!config) return { btu: null, refrig: null };

    if (config.btuNotice || config.refrigNotice) {
      return {
        btu: tosotNormalizePanelNotice(config.btuNotice),
        refrig: tosotNormalizePanelNotice(config.refrigNotice),
      };
    }

    if (config.noticeContent) {
      return {
        btu: tosotNormalizePanelNotice({
          title: config.noticeTitle,
          content: config.noticeContent,
        }),
        refrig: null,
      };
    }
  } catch (e) {
    return { btu: null, refrig: null };
  }

  return { btu: null, refrig: null };
}

function tosotParseCalculatorNoticesFromDom(container) {
  if (!container) return { btu: null, refrig: null };

  var fromConfig = tosotParseCalculatorNoticesFromLiveConfig(container);
  if (fromConfig.btu || fromConfig.refrig) return fromConfig;

  var settingsEl = container.matches('[data-tosot-calculator-section-settings]')
    ? container
    : container.querySelector('[data-tosot-calculator-section-settings]');

  var btu = tosotParsePanelNoticeFromSettings(settingsEl, 'btu');
  var refrig = tosotParsePanelNoticeFromSettings(settingsEl, 'refrig');

  if (!btu) {
    btu = tosotParsePanelNoticeFromPanelDom(container.querySelector('#tosot-panel-btu'));
  }
  if (!refrig) {
    refrig = tosotParsePanelNoticeFromPanelDom(container.querySelector('#tosot-panel-refrig'));
  }

  return { btu: btu, refrig: refrig };
}

function tosotNormalizeShopifyPath(path) {
  if (!path || path.indexOf('http') === 0) return path;
  if (path.charAt(0) !== '/') path = '/' + path;

  var root = window.Shopify && Shopify.routes && Shopify.routes.root;
  if (!root || root === '/') return path;

  var normalizedRoot = root.charAt(root.length - 1) === '/' ? root.slice(0, -1) : root;
  return normalizedRoot + path;
}

function tosotAbsoluteShopifyUrl(path) {
  if (!path) return path;
  if (path.indexOf('http') === 0) return path;
  return window.location.origin + tosotNormalizeShopifyPath(path);
}

function tosotGetCalculatorNoticeFetchUrls(contentInfo) {
  var trigger = contentInfo;
  if (!trigger || !trigger.getAttribute('data-calculator-notice-fetch-url')) {
    trigger = document.querySelector('[data-product-calculator-popup][data-calculator-notice-fetch-url]');
  }
  if (!trigger) {
    trigger = document.querySelector('[data-calculator-notice-fetch-url]');
  }
  if (!trigger) return { sectionUrl: null, pageUrl: null };

  return {
    sectionUrl: tosotAbsoluteShopifyUrl(trigger.getAttribute('data-calculator-notice-fetch-url')),
    pageUrl: tosotAbsoluteShopifyUrl(trigger.getAttribute('data-calculator-page-url')),
  };
}

function tosotAppendCacheBust(url) {
  if (!url) return url;
  return url + (url.indexOf('?') >= 0 ? '&' : '?') + '_=' + Date.now();
}

function tosotFetchNoticeFromCalculatorPageHtml(pageUrl) {
  if (!pageUrl) return Promise.resolve(null);

  return fetch(tosotAppendCacheBust(pageUrl), {
    credentials: 'same-origin',
    cache: 'no-store',
  })
    .then(function (response) {
      if (!response.ok) return null;
      return response.text();
    })
    .then(function (html) {
      if (!html) return null;
      var temp = document.createElement('div');
      temp.innerHTML = html;
      return tosotParseCalculatorSectionPayload(temp);
    })
    .catch(function () {
      return null;
    });
}

function tosotClearCalculatorNoticeCache() {
  window.TOSOT_CALCULATOR_NOTICE_CACHE = null;
  window.TOSOT_CALCULATOR_SECTION_CACHE = null;
  window.TOSOT_CALCULATOR_NOTICE_FETCH = null;
}

function tosotGetThemeNoticeFallback() {
  var el = document.querySelector('[data-calculator-theme-notice-fallback]');
  if (!el || !el.textContent.trim()) return null;

  try {
    var config = JSON.parse(el.textContent.trim());
    if (!config) return null;

    if (config.btuNotice) {
      return tosotNormalizePanelNotice(config.btuNotice);
    }

    if (!config.noticeContent || !String(config.noticeContent).trim()) return null;
    return {
      title: config.noticeTitle ? String(config.noticeTitle).trim() : '',
      content: String(config.noticeContent),
    };
  } catch (e) {
    return null;
  }
}

function tosotFetchCalculatorNoticeRemote(contentInfo) {
  var urls = tosotGetCalculatorNoticeFetchUrls(contentInfo);
  if (!urls.sectionUrl && !urls.pageUrl) {
    return Promise.resolve(
      tosotNormalizeCalculatorSectionPayload({
        notices: {
          btu: tosotGetThemeNoticeFallback(),
          refrig: null,
        },
        sectionRoot: null,
      })
    );
  }

  var sectionUrl = tosotAppendCacheBust(urls.sectionUrl);
  var pageUrl = urls.pageUrl;
  var fetchOpts = {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    },
  };

  return Promise.resolve()
    .then(function () {
      if (!sectionUrl) return null;
      return fetch(sectionUrl, fetchOpts)
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function (data) {
          var html = tosotGetSectionHtmlFromResponse(data, contentInfo);
          if (!html) return null;
          var temp = document.createElement('div');
          temp.innerHTML = html;
          return tosotParseCalculatorSectionPayload(temp);
        });
    })
    .then(function (payload) {
      if (!payload) return tosotFetchNoticeFromCalculatorPageHtml(pageUrl);
      if (tosotCalculatorPayloadHasNotices(payload)) return payload;
      return tosotFetchNoticeFromCalculatorPageHtml(pageUrl).then(function (pagePayload) {
        return tosotMergeCalculatorSectionPayload(payload, pagePayload);
      });
    })
    .catch(function () {
      return tosotFetchNoticeFromCalculatorPageHtml(pageUrl);
    })
    .then(function (payload) {
      return tosotNormalizeCalculatorSectionPayload(payload);
    });
}

function tosotParseCalculatorSectionPayload(container) {
  if (!container) return null;
  return {
    notices: tosotParseCalculatorNoticesFromDom(container),
    sectionRoot: container.querySelector('[data-tosot-calculator-root]'),
  };
}

function tosotNormalizeCalculatorSectionPayload(payload) {
  if (!payload) {
    var legacyNotice =
      tosotGetStoredSectionNotice() ||
      tosotGetStoredCalculatorLiveConfig() ||
      tosotGetThemeNoticeFallback();
    return {
      notices: {
        btu: legacyNotice,
        refrig: null,
      },
      sectionRoot: null,
    };
  }

  if (payload.notices) {
    return payload;
  }

  if (payload.btu || payload.refrig) {
    return { notices: payload, sectionRoot: payload.sectionRoot || null };
  }

  return {
    notices: {
      btu: payload,
      refrig: null,
    },
    sectionRoot: null,
  };
}

function tosotStoreCalculatorNotice(notice) {
  if (!notice) return;
  window.TOSOT_CALCULATOR_NOTICE_CACHE = notice;
  try {
    sessionStorage.setItem(
      'TOSOT_CALCULATOR_LIVE_CONFIG',
      JSON.stringify({
        noticeTitle: notice.title,
        noticeContent: notice.content,
      })
    );
  } catch (e) {
    /* ignore */
  }
}

function tosotStoreCalculatorSectionPayload(payload) {
  if (!payload) return;
  window.TOSOT_CALCULATOR_SECTION_CACHE = payload;
  if (payload.notices && payload.notices.btu) {
    tosotStoreCalculatorNotice(payload.notices.btu);
  }
}

function tosotFetchFreshCalculatorNotice(contentInfo) {
  tosotClearCalculatorNoticeCache();
  return tosotFetchCalculatorNoticeRemote(contentInfo).then(function (payload) {
    tosotStoreCalculatorSectionPayload(payload);
    return payload;
  });
}

function tosotPersistCalculatorLiveConfig() {
  var configEl = document.getElementById('tosot-calculator-live-config');
  if (!configEl || !configEl.textContent.trim()) return;

  var raw = configEl.textContent.trim();
  try {
    sessionStorage.setItem('TOSOT_CALCULATOR_LIVE_CONFIG', raw);
    localStorage.setItem('TOSOT_CALCULATOR_SECTION_NOTICE', raw);
  } catch (e) {
    /* ignore quota / private mode */
  }
}

function tosotGetStoredSectionNotice() {
  try {
    var raw = localStorage.getItem('TOSOT_CALCULATOR_SECTION_NOTICE');
    if (!raw) return null;
    var config = JSON.parse(raw);
    if (!config || !config.noticeContent || !String(config.noticeContent).trim()) return null;
    return {
      title: config.noticeTitle ? String(config.noticeTitle).trim() : '',
      content: String(config.noticeContent),
    };
  } catch (e) {
    return null;
  }
}

function tosotGetStoredCalculatorLiveConfig() {
  try {
    var raw = sessionStorage.getItem('TOSOT_CALCULATOR_LIVE_CONFIG');
    if (!raw) return null;
    var config = JSON.parse(raw);
    if (!config || !config.noticeContent || !String(config.noticeContent).trim()) return null;
    return {
      title: config.noticeTitle ? String(config.noticeTitle).trim() : '',
      content: String(config.noticeContent),
    };
  } catch (e) {
    return null;
  }
}

function tosotGetCachedCalculatorNotice(contentInfo) {
  if (window.TOSOT_CALCULATOR_SECTION_CACHE) {
    return Promise.resolve(window.TOSOT_CALCULATOR_SECTION_CACHE);
  }

  var settingsEl = document.querySelector('[data-tosot-calculator-section-settings]');
  if (settingsEl) {
    var payload = tosotParseCalculatorSectionPayload(settingsEl.closest('.section-calculator') || document);
    if (payload && (payload.notices.btu || payload.notices.refrig || payload.sectionRoot)) {
      tosotStoreCalculatorSectionPayload(payload);
      return Promise.resolve(payload);
    }
  }

  var calculatorRoot = document.querySelector('[data-tosot-calculator-root]');
  if (calculatorRoot && !calculatorRoot.closest('[data-product-calculator-popup]')) {
    var payloadFromRoot = tosotParseCalculatorSectionPayload(calculatorRoot.parentElement || document);
    if (payloadFromRoot && (payloadFromRoot.notices.btu || payloadFromRoot.notices.refrig)) {
      payloadFromRoot.sectionRoot = calculatorRoot;
      tosotStoreCalculatorSectionPayload(payloadFromRoot);
      return Promise.resolve(payloadFromRoot);
    }
  }

  var urls = tosotGetCalculatorNoticeFetchUrls(contentInfo);
  if (!urls.sectionUrl && !urls.pageUrl) {
    return Promise.resolve(tosotNormalizeCalculatorSectionPayload(null));
  }

  if (window.TOSOT_CALCULATOR_NOTICE_FETCH) {
    return window.TOSOT_CALCULATOR_NOTICE_FETCH;
  }

  window.TOSOT_CALCULATOR_NOTICE_FETCH = tosotFetchCalculatorNoticeRemote(contentInfo).then(function (payload) {
    tosotStoreCalculatorSectionPayload(payload);
    window.TOSOT_CALCULATOR_NOTICE_FETCH = null;
    return payload;
  });

  return window.TOSOT_CALCULATOR_NOTICE_FETCH;
}

function tosotApplyCalculatorNoticeToPopup(root, notice, panelKey) {
  if (!root || !notice || !notice.content || !notice.content.trim()) return false;

  var panel = root.querySelector('#tosot-panel-' + panelKey);
  if (!panel) return false;

  var mount =
    panelKey === 'btu'
      ? panel.querySelector('.tosot-calc-card')
      : panel.querySelector('.tosot-refrig-body');
  if (!mount) return false;

  var existing = mount.querySelector('.tosot-calc-footer-content');
  if (existing) existing.remove();

  var footer = document.createElement('div');
  footer.className = 'tosot-calc-footer-content' + (panelKey === 'refrig' ? ' tosot-refrig-notice' : '');

  var noticeWrap = document.createElement('div');
  noticeWrap.className = 'tosot-calc-notice';

  var title = document.createElement('p');
  title.className = 'tosot-calc-notice-title';
  title.setAttribute('data-tosot-block-copy', 'notice_title');
  title.textContent = notice.title || 'Precautions';

  var body = document.createElement('div');
  body.className = 'tosot-calc-notice-body rte';
  body.setAttribute('data-tosot-block-copy', 'notice_content');
  body.innerHTML = notice.content;

  noticeWrap.appendChild(title);
  noticeWrap.appendChild(body);
  footer.appendChild(noticeWrap);
  mount.appendChild(footer);

  return true;
}

function tosotApplyCalculatorNoticesToPopup(root, notices) {
  if (!root || !notices) return false;
  var applied = false;
  if (notices.btu) applied = tosotApplyCalculatorNoticeToPopup(root, notices.btu, 'btu') || applied;
  if (notices.refrig) applied = tosotApplyCalculatorNoticeToPopup(root, notices.refrig, 'refrig') || applied;
  return applied;
}

function tosotGetPanelCopyConfig(root, panelKey) {
  if (!root || !panelKey) return {};
  var el = root.querySelector('[data-tosot-copy-config="' + panelKey + '"]');
  if (!el || !el.textContent.trim()) return {};
  try {
    return JSON.parse(el.textContent.trim());
  } catch (e) {
    return {};
  }
}

function tosotSyncCalculatorCopyConfig(popupRoot, sectionRoot) {
  if (!popupRoot || !sectionRoot) return false;
  var applied = false;
  ['btu', 'refrig'].forEach(function (panelKey) {
    var src = sectionRoot.querySelector('[data-tosot-copy-config="' + panelKey + '"]');
    var dest = popupRoot.querySelector('[data-tosot-copy-config="' + panelKey + '"]');
    if (!src) return;
    if (!dest) {
      dest = src.cloneNode(true);
      var panel = popupRoot.querySelector('#tosot-panel-' + panelKey);
      if (panel) {
        panel.insertBefore(dest, panel.firstChild);
        applied = true;
      }
    } else {
      dest.textContent = src.textContent;
      applied = true;
    }
  });
  return applied;
}

function tosotApplyBlockCopyElement(src, dest) {
  if (!src || !dest) return;
  var copyAttr = src.getAttribute('data-tosot-copy-attr');
  if (copyAttr) {
    dest.setAttribute(copyAttr, src.getAttribute(copyAttr) || src.textContent);
    return;
  }
  if (dest.classList.contains('tosot-calc-notice-body')) {
    dest.innerHTML = src.innerHTML;
  } else {
    dest.textContent = src.textContent;
  }
}

function tosotUpdateCalculatorPanelSubtitle(root, activeTab) {
  if (!root) return;

  var wrap = root.querySelector('[data-tosot-panel-subtitles-switchable]');
  if (!wrap) return;

  var tab = activeTab;
  if (!tab) {
    var activeBtn = root.querySelector('.tosot-tab-btn.tosot-tab-active[id^="tosot-tab-"]');
    if (activeBtn) {
      tab = activeBtn.id.replace('tosot-tab-', '');
    } else {
      tab = 'btu';
    }
  }

  wrap.querySelectorAll('[data-tosot-panel-subtitle]').forEach(function (el) {
    el.classList.toggle('tosot-panel-subtitle-active', el.getAttribute('data-tosot-panel-subtitle') === tab);
  });
}

function tosotSyncCalculatorPanelSubtitles(popupRoot, sectionRoot) {
  if (!popupRoot || !sectionRoot) return false;

  var applied = false;
  ['btu', 'refrig'].forEach(function (panelKey) {
    var src = sectionRoot.querySelector('[data-tosot-panel-subtitle="' + panelKey + '"]');
    var dest = popupRoot.querySelector('[data-tosot-panel-subtitle="' + panelKey + '"]');
    if (src && dest) {
      dest.textContent = src.textContent;
      dest.className = src.className;
      applied = true;
    }
  });

  if (applied) {
    tosotUpdateCalculatorPanelSubtitle(popupRoot);
  }

  return applied;
}

function tosotApplyBlockCopyToPopup(popupRoot, sectionRoot) {
  if (!popupRoot || !sectionRoot) return false;

  var applied = false;
  ['btu', 'refrig'].forEach(function (panelKey) {
    var popupPanel = popupRoot.querySelector('#tosot-panel-' + panelKey);
    var sectionPanel = sectionRoot.querySelector('#tosot-panel-' + panelKey);
    if (!popupPanel || !sectionPanel) return;

    var sectionNotice = sectionPanel.querySelector('.tosot-calc-footer-content .tosot-calc-notice-body');
    var popupNotice = popupPanel.querySelector('.tosot-calc-footer-content .tosot-calc-notice-body');
    if (sectionNotice && popupNotice) {
      popupNotice.innerHTML = sectionNotice.innerHTML;
      var sectionTitle = sectionPanel.querySelector('.tosot-calc-footer-content .tosot-calc-notice-title');
      var popupTitle = popupPanel.querySelector('.tosot-calc-footer-content .tosot-calc-notice-title');
      if (sectionTitle && popupTitle) popupTitle.textContent = sectionTitle.textContent;
      applied = true;
    }

    sectionPanel.querySelectorAll('[data-tosot-block-copy]').forEach(function (src) {
      var key = src.getAttribute('data-tosot-block-copy');
      var dest = popupPanel.querySelector('[data-tosot-block-copy="' + key + '"]');
      if (!dest) return;
      tosotApplyBlockCopyElement(src, dest);
      applied = true;
    });
  });

  if (tosotSyncCalculatorCopyConfig(popupRoot, sectionRoot)) {
    applied = true;
  }

  ['btu', 'refrig'].forEach(function (panelKey) {
    var srcTab = sectionRoot.querySelector('#tosot-tab-' + panelKey);
    var destTab = popupRoot.querySelector('#tosot-tab-' + panelKey);
    if (srcTab && destTab) {
      destTab.textContent = srcTab.textContent;
      applied = true;
    }
  });

  var srcPlaceholder = sectionRoot.querySelector('#tosot-btu-result-container .tosot-placeholder-text');
  var destPlaceholder = popupRoot.querySelector('#tosot-btu-result-container .tosot-placeholder-text');
  if (srcPlaceholder && destPlaceholder) {
    destPlaceholder.textContent = srcPlaceholder.textContent;
    applied = true;
  }

  if (tosotSyncCalculatorPanelSubtitles(popupRoot, sectionRoot)) {
    applied = true;
  }

  return applied;
}

function tosotGetNoticesFromPopupRoot(root) {
  return {
    btu: tosotParsePanelNoticeFromPanelDom(root.querySelector('#tosot-panel-btu')),
    refrig: tosotParsePanelNoticeFromPanelDom(root.querySelector('#tosot-panel-refrig')),
  };
}

function tosotPanelNoticesMatch(a, b) {
  function matchOne(x, y) {
    if (!x && !y) return true;
    if (!x || !y) return false;
    var titleA = (x.title || '').trim();
    var titleB = (y.title || '').trim();
    var contentA = (x.content || '').replace(/\s+/g, ' ').trim();
    var contentB = (y.content || '').replace(/\s+/g, ' ').trim();
    return titleA === titleB && contentA === contentB;
  }
  return matchOne(a && a.btu, b && b.btu) && matchOne(a && a.refrig, b && b.refrig);
}

function tosotSyncCalculatorSectionToPopup(contentInfo, payload) {
  var root = contentInfo && contentInfo.querySelector('[data-tosot-calculator-root]');
  if (!root || !payload) return false;

  var applied = false;
  if (payload.notices) {
    applied = tosotApplyCalculatorNoticesToPopup(root, payload.notices) || applied;
  }
  if (payload.sectionRoot) {
    applied = tosotApplyBlockCopyToPopup(root, payload.sectionRoot) || applied;
  }
  if (applied) root.dataset.noticeSynced = 'true';
  return applied;
}

function tosotSyncCalculatorNoticeFromPage(contentInfo) {
  var root = contentInfo && contentInfo.querySelector('[data-tosot-calculator-root]');
  if (!root) return Promise.resolve(false);

  var isProductPopup = contentInfo && contentInfo.hasAttribute('data-product-calculator-popup');
  var hasFooter =
    !!root.querySelector('#tosot-panel-btu .tosot-calc-footer-content') ||
    !!root.querySelector('#tosot-panel-refrig .tosot-calc-footer-content');

  if (!isProductPopup && hasFooter) {
    root.dataset.noticeSynced = 'true';
    return Promise.resolve(true);
  }

  var fetchRemote = isProductPopup ? tosotFetchFreshCalculatorNotice : tosotGetCachedCalculatorNotice;

  return fetchRemote(contentInfo).then(function (payload) {
    payload = tosotNormalizeCalculatorSectionPayload(payload);
    if (!payload.notices.btu && !payload.notices.refrig && !payload.sectionRoot) {
      return hasFooter;
    }
    return tosotSyncCalculatorSectionToPopup(contentInfo, payload) || hasFooter;
  });
}

function tosotApplyCalculatorPopupLayout(modal) {
  if (!modal || !modal.classList.contains('product-calculator-popup-modal')) return;

  var content = modal.querySelector('.product-calculator-popup__content');
  var contentInfo = modal.querySelector('[data-product-calculator-popup]');
  var wrapper = contentInfo && contentInfo.querySelector('.tosot-combined-wrapper--product-popup');
  var stage = wrapper && wrapper.querySelector('[data-tosot-panels-stage]');
  if (!content || !contentInfo || !wrapper || !stage) return;

  var isMobile = tosotIsCalculatorPopupMobile();
  modal.classList.toggle('tosot-calculator-popup--mobile-layout', isMobile);

  if (isMobile && !modal.hasAttribute('open')) return;

  var activePanel = stage.querySelector('.tosot-tab-panel.tosot-panel-active');
  if (!activePanel) return;

  var availableStageHeight = tosotGetPopupStageAvailableHeight(modal, wrapper, contentInfo);
  var naturalHeight = tosotMeasureCalculatorPanel(stage, activePanel);
  if (naturalHeight < 1) return;

  var needsCompact = naturalHeight > availableStageHeight;
  var stageHeight = needsCompact ? availableStageHeight : naturalHeight;

  wrapper.classList.toggle('tosot-combined-wrapper--popup-compact', needsCompact);
  wrapper.dataset.tosotStageHeight = String(stageHeight);

  if (needsCompact) {
    stage.style.height = stageHeight + 'px';
    stage.style.minHeight = stageHeight + 'px';
    stage.style.maxHeight = stageHeight + 'px';
    stage.style.overflow = 'hidden';
  } else {
    stage.style.height = '';
    stage.style.minHeight = '';
    stage.style.maxHeight = '';
    stage.style.overflow = 'visible';
  }

  contentInfo.style.height = '';
  contentInfo.style.maxHeight = '';
  contentInfo.style.minHeight = '';
  contentInfo.style.flex = '';
  contentInfo.style.overflow = needsCompact ? 'hidden' : 'visible';

  content.style.height = '';
  content.style.minHeight = '';
  content.style.display = '';
  content.style.flexDirection = '';
  content.style.overflow = needsCompact ? 'hidden' : 'visible';

  if (isMobile) {
    content.style.maxHeight =
      'calc(100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px) - 1rem)';
  } else {
    content.style.maxHeight = 'calc(100dvh - 1.5rem)';
  }
}

function tosotEnsureCalculatorPopupPrepared(contentInfo, root) {
  if (!contentInfo || !root || root.dataset.popupPrepared === 'true') return;
  tosotPrepareCalculatorPopupRoot(contentInfo, root);
  tosotInitRefrigerantCalculator(root);
  root.dataset.popupPrepared = 'true';
}

function tosotWarmCalculatorPopup(modal, options) {
  if (!modal) return Promise.resolve();

  var contentInfo = modal.querySelector('[data-product-calculator-popup]');
  var root = contentInfo && contentInfo.querySelector('[data-tosot-calculator-root]');
  if (!contentInfo || !root) return Promise.resolve();

  if (modal.dataset.popupWarming === 'true') {
    return modal._tosotWarmPromise || Promise.resolve();
  }

  var freshNotice = options && options.freshNotice;
  var noticeTask = freshNotice ? tosotFetchFreshCalculatorNotice(contentInfo) : tosotGetCachedCalculatorNotice(contentInfo);

  modal.dataset.popupWarming = 'true';
  modal._tosotWarmPromise = Promise.resolve()
    .then(function () {
      tosotEnsureCalculatorPopupPrepared(contentInfo, root);
      return noticeTask;
    })
    .then(function (payload) {
      payload = tosotNormalizeCalculatorSectionPayload(payload);
      tosotSyncCalculatorSectionToPopup(contentInfo, payload);
      tosotApplyCalculatorPopupLayout(modal);
      modal.dataset.popupLayoutReady = 'true';
    })
    .finally(function () {
      modal.dataset.popupWarming = 'false';
      modal._tosotWarmPromise = null;
    });

  return modal._tosotWarmPromise;
}

function tosotWarmAllCalculatorPopups(options) {
  document.querySelectorAll('.product-calculator-popup-modal').forEach(function (modal) {
    tosotWarmCalculatorPopup(modal, options);
  });
}

function tosotInitCalculatorPopupLayout(modal) {
  var contentInfo = modal.querySelector('[data-product-calculator-popup]');
  var root = contentInfo && contentInfo.querySelector('[data-tosot-calculator-root]');

  tosotEnsureCalculatorPopupPrepared(contentInfo, root);
  tosotApplyCalculatorPopupLayout(modal);

  var noticeBefore = root ? tosotGetNoticesFromPopupRoot(root) : null;

  tosotSyncCalculatorNoticeFromPage(contentInfo).then(function () {
    var noticeAfter = root ? tosotGetNoticesFromPopupRoot(root) : null;
    if (
      modal.dataset.popupLayoutReady === 'true' &&
      root.dataset.noticeSynced === 'true' &&
      tosotPanelNoticesMatch(noticeBefore, noticeAfter)
    ) {
      return;
    }
    tosotApplyCalculatorPopupLayout(modal);
    modal.dataset.popupLayoutReady = 'true';
  });
}

function tosotBindCalculatorPopupOpeners() {
  if (document.body.dataset.tosotCalculatorOpenersBound === 'true') return;
  document.body.dataset.tosotCalculatorOpenersBound = 'true';

  var warmFromOpener = function (opener) {
    var selector = opener.getAttribute('data-modal');
    if (!selector) return;
    var modal = document.querySelector(selector);
    if (!modal) return;
    var needsFresh = modal.dataset.popupLayoutReady !== 'true';
    tosotWarmCalculatorPopup(modal, { freshNotice: needsFresh });
  };

  document.addEventListener(
    'mouseover',
    function (event) {
      var opener = event.target.closest('.product-calculator-popup__opener');
      if (opener) warmFromOpener(opener);
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (event) {
      var opener = event.target.closest('.product-calculator-popup__opener');
      if (opener) warmFromOpener(opener);
    },
    true
  );

  document.addEventListener(
    'touchstart',
    function (event) {
      var opener = event.target.closest('.product-calculator-popup__opener');
      if (opener) warmFromOpener(opener);
    },
    { capture: true, passive: true }
  );
}

function tosotBindCalculatorPopupModals() {
  document.querySelectorAll('.product-calculator-popup-modal').forEach(function (modal) {
    if (modal.dataset.tosotPopupBound === 'true') return;
    modal.dataset.tosotPopupBound = 'true';

    var observer = new MutationObserver(function () {
      if (modal.hasAttribute('open')) {
        tosotInitCalculatorPopupLayout(modal);
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });

    var resizeTimer;
    window.addEventListener('resize', function () {
      if (!modal.hasAttribute('open')) return;
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        tosotApplyCalculatorPopupLayout(modal);
      }, 150);
    });
  });

  tosotBindCalculatorPopupOpeners();
}

function tosotSwitchTab(tab, evt) {
  var root = tosotGetCalculatorRoot(evt && evt.currentTarget);
  if (!root) return;

  var tabs = [];
  root.querySelectorAll('.tosot-tab-btn[id^="tosot-tab-"]').forEach(function (btn) {
    tabs.push(btn.id.replace('tosot-tab-', ''));
  });
  var activePanel = null;
  tabs.forEach(function (t) {
    var btn = root.querySelector('#tosot-tab-' + t);
    var panel = root.querySelector('#tosot-panel-' + t);
    if (!btn || !panel) return;
    if (t === tab) {
      btn.classList.add('tosot-tab-active');
      btn.setAttribute('aria-selected', 'true');
      panel.classList.add('tosot-panel-active');
      activePanel = panel;
    } else {
      btn.classList.remove('tosot-tab-active');
      btn.setAttribute('aria-selected', 'false');
      panel.classList.remove('tosot-panel-active');
    }
  });

  if (activePanel) activePanel.scrollTop = 0;

  tosotUpdateCalculatorPanelSubtitle(root, tab);

  var modal = root.closest('.product-calculator-popup-modal');
  if (modal && modal.hasAttribute('open')) {
    tosotApplyCalculatorPopupLayout(modal);
  }
}

function tosotShouldOpenHvacProposal(hashValue) {
  return String(hashValue || '').toLowerCase() === '#hvac-proposal';
}

function tosotLinkTargetsHvacProposal(linkHref) {
  if (!linkHref) return false;
  try {
    return new URL(linkHref, window.location.href).hash.toLowerCase() === '#hvac-proposal';
  } catch (e) {
    return String(linkHref).toLowerCase() === '#hvac-proposal';
  }
}

function tosotIsSamePageLink(linkHref) {
  try {
    var target = new URL(linkHref, window.location.href);
    var current = new URL(window.location.href);
    var normalizePath = function (pathname) {
      return pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
    };
    return (
      target.origin === current.origin &&
      normalizePath(target.pathname) === normalizePath(current.pathname)
    );
  } catch (e) {
    return true;
  }
}

function tosotSwitchRootToHvacProposal(root) {
  if (!root) return;
  var proposalBtn = root.querySelector('#tosot-tab-proposal');
  if (!proposalBtn || !root.querySelector('#tosot-panel-proposal')) return;
  tosotSwitchTab('proposal', { currentTarget: proposalBtn });
}

function tosotInitHvacProposalHashRouting() {
  if (document.body && document.body.dataset.tosotHvacProposalHashBound === 'true') return;
  if (document.body) document.body.dataset.tosotHvacProposalHashBound = 'true';

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest && event.target.closest('.tosot-calc-notice-body a');
    if (!link) return;
    var anchorTarget = link.getAttribute('href') || link.getAttribute('src');
    if (!tosotLinkTargetsHvacProposal(anchorTarget)) return;
    if (!tosotIsSamePageLink(anchorTarget)) return;
    event.preventDefault();
    var root = tosotGetCalculatorRoot(link) || document.querySelector('[data-tosot-calculator-root]');
    tosotSwitchRootToHvacProposal(root);
    if (window.location.hash !== '#hvac-proposal') {
      window.history.replaceState(null, '', '#hvac-proposal');
    }
  });

  if (tosotShouldOpenHvacProposal(window.location.hash)) {
    document.querySelectorAll('[data-tosot-calculator-root]').forEach(function (root) {
      tosotSwitchRootToHvacProposal(root);
    });
  }
}
var TOSOT_PRODUCTS = {
  '9000': {
    cosmo: {
      url: 'https://tosotdirect.com/collections/split-acs/products/tosot-9-000-btu-ductless-mini-split-inverter-air-conditioner-system-heat-pump',
      features: 'Budget-friendly · Inverter technology · WiFi enabled',
      tag: 'value',
    },
  },
  '12000': {
    cosmo: {
      url: 'https://tosotdirect.com/collections/single-zone/products/tosot-12-000-btu-ductless-mini-split-inverter-air-conditioner-system-heat-pump-120v',
      features: 'Great value · Inverter compressor · Easy installation',
      tag: 'value',
    },
    aoraki: {
      url: 'https://tosotdirect.com/products/aoraki-24-5-seer2-12-000-btu-heat-pump-mini-split-ac-w-erv-system',
      features: 'Optional ERV system · 24.5 SEER2 · High efficiency',
      tag: 'erv',
    },
  },
  '18000': {
    cosmo: {
      url: 'https://tosotdirect.com/products/tosot-18-000-btu-ductless-mini-split-inverter-air-conditioner-system-heat-pump',
      features: 'Excellent value · Powerful cooling · Quiet operation',
      tag: 'value',
    },
    aoraki: {
      url: 'https://tosotdirect.com/collections/single-zone/products/aoraki-24-5-seer2-18-000-btu-heat-pump-mini-split-ac-w-erv-system',
      features: 'Optional ERV · 24.5 SEER2 · Premium performance',
      tag: 'erv',
    },
  },
  '24000': {
    cosmo: {
      url: 'https://tosotdirect.com/collections/single-zone/products/24-000-btu-mini-split-heat-pump-air-conditioner-230v',
      features: 'Best value for large rooms · High capacity · Efficient',
      tag: 'value',
    },
    aoraki: {
      url: 'https://tosotdirect.com/collections/split-acs/products/aoraki-24-5-seer2-1224btu-heat-pump-mini-split-ac-w-erv-system',
      features: 'Optional ERV · 24.5 SEER2 · Top efficiency',
      tag: 'erv',
    },
  },
  '30000': {
    cosmo: {
      url: 'https://tosotdirect.com/collections/single-zone/products/30-000-btu-mini-split-heat-pump-air-conditioner-230v',
      features: 'Large area coverage · Powerful performance · Great value',
      tag: 'value',
    },
  },
  '36000': {
    cosmo: {
      url: 'https://tosotdirect.com/collections/single-zone/products/36-000-btu-mini-split-ac',
      features: 'Maximum cooling power · Whole-home comfort · Best value',
      tag: 'value',
    },
    commercial_ducted: {
      url: 'https://tosotdirect.com/products/34-000-btu-ducted-mini-split-air-conditioner',
      features: 'Ducted installation · Commercial-grade · Flexible design',
      tag: 'commercial',
    },
    commercial_floor: {
      url: 'https://tosotdirect.com/products/36-000-btu-floor-standing-mini-split-air-conditioner',
      features: 'Floor-standing unit · No wall installation · Commercial quality',
      tag: 'commercial',
    },
    commercial_ceiling: {
      url: 'https://tosotdirect.com/collections/light-commercial-split-ac/products/36-000-btu-ceiling-cassette-mini-split-air-conditioner',
      features: 'Ceiling cassette · Discreet design · Commercial-grade',
      tag: 'commercial',
    },
  },
};

function tosot_calculateBTU(evt) {
  var root = tosotGetCalculatorRoot(evt && evt.target);
  if (!root) return;

  var lengthEl = root.querySelector('#tosot-btu-length');
  var widthEl = root.querySelector('#tosot-btu-width');
  var resultContainer = root.querySelector('#tosot-btu-result-container');
  if (!lengthEl || !widthEl || !resultContainer) return;

  var length = parseFloat(lengthEl.value);
  var width = parseFloat(widthEl.value);
  var roomType = root.querySelector('#tosot-btu-room-type').value;
  var ceiling = root.querySelector('#tosot-btu-ceiling').value;
  var climate = root.querySelector('#tosot-btu-climate').value;
  var insulation = root.querySelector('#tosot-btu-insulation').value;

  var btuCopy = tosotGetPanelCopyConfig(root, 'btu');

  if (!length || !width) {
    alert(btuCopy.alertMissingDimensions || 'Please enter room dimensions.');
    return;
  }

  var area = length * width;
  var recommendation = '';
  var coverage = '';
  var products = [];

  if (area <= 450) {
    recommendation = '9,000 BTU';
    coverage = 'Best for rooms up to 450 sq.ft.';
    products.push({ name: 'TOSOT COSMO 9K', series: 'cosmo', productKey: '9000', tag: 'value' });
  } else if (area <= 750) {
    recommendation = '12,000 BTU';
    coverage = 'Best for rooms 450 - 750 sq.ft.';
    if (roomType === 'garage' || roomType === 'basement' || roomType === 'workshop' || roomType === 'sunroom') {
      products.push({ name: 'TOSOT Aoraki 12K', series: 'aoraki', productKey: '12000', tag: 'erv' });
    } else {
      products.push({ name: 'TOSOT COSMO 12K', series: 'cosmo', productKey: '12000', tag: 'value' });
    }
  } else if (area <= 1000) {
    recommendation = '18,000 BTU';
    coverage = 'Best for rooms 750 - 1,000 sq.ft.';
    if (roomType === 'garage' || roomType === 'basement' || roomType === 'workshop' || roomType === 'sunroom') {
      products.push({ name: 'TOSOT Aoraki 18K', series: 'aoraki', productKey: '18000', tag: 'erv' });
    } else {
      products.push({ name: 'TOSOT COSMO 18K', series: 'cosmo', productKey: '18000', tag: 'value' });
    }
  } else if (area <= 1500) {
    recommendation = '24,000 BTU';
    coverage = 'Best for rooms 1,000 - 1,500 sq.ft.';
    if (roomType === 'garage' || roomType === 'basement' || roomType === 'workshop' || roomType === 'sunroom') {
      products.push({ name: 'TOSOT Aoraki 24K', series: 'aoraki', productKey: '24000', tag: 'erv' });
    } else if (roomType === 'office' || roomType === 'living_room') {
      products.push({ name: 'TOSOT COSMO 24K', series: 'cosmo', productKey: '24000', tag: 'value' });
      products.push({ name: 'TOSOT Aoraki 24K', series: 'aoraki', productKey: '24000', tag: 'erv' });
    } else {
      products.push({ name: 'TOSOT COSMO 24K', series: 'cosmo', productKey: '24000', tag: 'value' });
    }
  } else if (area <= 1950) {
    recommendation = '30,000 BTU';
    coverage = 'Best for rooms 1,500 - 1,950 sq.ft.';
    products.push({ name: 'TOSOT COSMO 30K', series: 'cosmo', productKey: '30000', tag: 'value' });
  } else {
    recommendation = '36,000 BTU';
    coverage = 'Best for rooms 1,950 - 2,400 sq.ft.';
    if (roomType === 'office' || roomType === 'living_room') {
      products.push({ name: 'TOSOT COSMO 36K', series: 'cosmo', productKey: '36000', tag: 'value' });
      products.push({ name: 'TOSOT Ducted 34K', series: 'commercial_ducted', productKey: '36000', tag: 'commercial' });
      products.push({ name: 'TOSOT Floor Standing 36K', series: 'commercial_floor', productKey: '36000', tag: 'commercial' });
      products.push({ name: 'TOSOT Ceiling Cassette 36K', series: 'commercial_ceiling', productKey: '36000', tag: 'commercial' });
    } else {
      products.push({ name: 'TOSOT COSMO 36K', series: 'cosmo', productKey: '36000', tag: 'value' });
    }
  }

  var resultTitle = btuCopy.resultTitle || 'Your Suggested System';
  var resultRoomSizeLabel = btuCopy.resultRoomSizeLabel || 'Estimated room size:';
  var resultFooterNote =
    btuCopy.resultFooterNote ||
    'This recommendation is optimized based on room type, climate, insulation quality, and TOSOT product matching.';
  var btnViewProduct = btuCopy.btnViewProduct || 'View Product';
  var tagLabels = {
    erv: btuCopy.tagErv || 'Aoraki',
    value: btuCopy.tagValue || 'Value',
    commercial: btuCopy.tagCommercial || 'Commercial',
  };

  var productsHTML = '';
  if (products.length > 1) {
    productsHTML = '<div class="tosot-multiple-products">';
    products.forEach(function (product) {
      var productData = TOSOT_PRODUCTS[product.productKey] && TOSOT_PRODUCTS[product.productKey][product.series];
      if (productData) {
        var tagLabel = tagLabels[product.tag] || tagLabels.value;
        var tagHTML = '<span class="tosot-tag tosot-tag-' + product.tag + '">' + tagLabel + '</span>';
        productsHTML +=
          '<div class="tosot-product-card">' +
          '<div>' +
          tagHTML +
          '</div>' +
          '<p class="tosot-product-name" style="margin-top:12px;">' +
          product.name +
          '</p>' +
          '<p class="tosot-product-features">' +
          productData.features +
          '</p>' +
          '<a href="' +
          productData.url +
          '" target="_blank" rel="noopener noreferrer" class="tosot-btn-view-product">' +
          btnViewProduct +
          '</a>' +
          '</div>';
      }
    });
    productsHTML += '</div>';
  } else if (products.length === 1) {
    var singleProduct = products[0];
    var singleProductData = TOSOT_PRODUCTS[singleProduct.productKey] && TOSOT_PRODUCTS[singleProduct.productKey][singleProduct.series];
    if (singleProductData) {
      var singleTagLabel = tagLabels[singleProduct.tag] || tagLabels.value;
      var singleTagHTML = '<span class="tosot-tag tosot-tag-' + singleProduct.tag + '">' + singleTagLabel + '</span>';
      productsHTML =
        '<div class="tosot-product-card">' +
        '<div>' +
        singleTagHTML +
        '</div>' +
        '<p class="tosot-product-name" style="margin-top:12px;">' +
        singleProduct.name +
        '</p>' +
        '<p class="tosot-product-features">' +
        singleProductData.features +
        '</p>' +
        '<a href="' +
        singleProductData.url +
        '" target="_blank" rel="noopener noreferrer" class="tosot-btn-view-product">' +
        btnViewProduct +
        '</a>' +
        '</div>';
    }
  }

  var resultHTML =
    '<div class="tosot-result-card">' +
    '<div style="margin-top:24px;">' +
    '<p class="tosot-result-title">' +
    resultTitle +
    '</p>' +
    '<div class="tosot-result-btu">' +
    recommendation +
    '</div>' +
    '<p class="tosot-result-coverage">' +
    coverage +
    '</p>' +
    '</div>' +
    productsHTML +
    '<div class="tosot-result-details">' +
    '<p><strong>' +
    resultRoomSizeLabel +
    '</strong> ' +
    Math.round(area) +
    ' sq.ft.</p>' +
    '<p style="margin-top:12px;">' +
    resultFooterNote +
    '</p>' +
    '</div>' +
    '</div>';

  resultContainer.innerHTML = resultHTML;

  var modal = root.closest('.product-calculator-popup-modal');
  if (modal && modal.hasAttribute('open')) {
    window.requestAnimationFrame(function () {
      tosotApplyCalculatorPopupLayout(modal);
    });
  }
}

function tosot_handleReset(evt) {
  var root = tosotGetCalculatorRoot(evt && evt.target);
  if (!root) return;

  var lengthEl = root.querySelector('#tosot-btu-length');
  var resultContainer = root.querySelector('#tosot-btu-result-container');
  if (!lengthEl || !resultContainer) return;

  lengthEl.value = '';
  root.querySelector('#tosot-btu-width').value = '';
  root.querySelector('#tosot-btu-room-type').value = 'bedroom';
  root.querySelector('#tosot-btu-ceiling').value = '8';
  root.querySelector('#tosot-btu-climate').value = 'mixed';
  root.querySelector('#tosot-btu-insulation').value = 'average';
  var placeholderEl = root.querySelector('[data-tosot-block-copy="result_placeholder"]');
  var placeholderText = placeholderEl
    ? placeholderEl.textContent
    : 'Enter your room details and click Calculate to see recommendations';
  resultContainer.innerHTML =
    '<div class="tosot-result-placeholder">' +
    '<p class="tosot-placeholder-text">' +
    placeholderText +
    '</p>' +
    '</div>';

  var modal = root.closest('.product-calculator-popup-modal');
  if (modal && modal.hasAttribute('open')) {
    window.requestAnimationFrame(function () {
      tosotApplyCalculatorPopupLayout(modal);
    });
  }
}

/* ===================== REFRIGERANT CALCULATOR LOGIC ===================== */
function tosotInitRefrigerantCalculator(root) {
  if (!root || root.dataset.refrigInit === 'true') return;

  var seriesSelect = root.querySelector('#tosot-refrig-series');
  if (!seriesSelect) return;

  root.dataset.refrigInit = 'true';

  var fd = {
    cosmo: {
      standardLength: 16.4,
      refillThreshold: 25,
      refrigerantType: 'R32',
      models: {
        '9K115': { name: '9K115', refillRate: 0.2, maxLength: 65.6 },
        '9K230': { name: '9K230', refillRate: 0.2, maxLength: 65.6 },
        '12K115': { name: '12K115', refillRate: 0.2, maxLength: 65.6 },
        '12K230': { name: '12K230', refillRate: 0.2, maxLength: 65.6 },
        '18K': { name: '18K', refillRate: 0.2, maxLength: 131.2 },
        '24K': { name: '24K', refillRate: 0.2, maxLength: 131.2 },
        '30K': { name: '30K', refillRate: 0.4, maxLength: 131.2 },
        '36K': { name: '36K', refillRate: 0.4, maxLength: 131.2 },
      },
    },
    light_commercial: {
      standardLength: 16.4,
      refillThreshold: 25,
      refrigerantType: 'R32',
      models: {
        'All Models': { name: 'All Models', refillRate: 0.4, maxLength: 131.2 },
      },
    },
    aoraki: {
      standardLength: 16.4,
      refillThreshold: 25,
      refrigerantType: 'R32',
      models: {
        '12K11': { name: '12K11', refillRate: 0.2, maxLength: 65.6 },
        '12K23': { name: '12K23', refillRate: 0.2, maxLength: 65.6 },
        '18K': { name: '18K', refillRate: 0.2, maxLength: 131.2 },
        '24K': { name: '24K', refillRate: 0.4, maxLength: 131.2 },
      },
    },
    central_heat_pump: {
      standardLength: 16.4,
      refillThreshold: 25,
      refrigerantType: 'R32',
      models: {
        'All model': { name: 'All model', refillRate: 0.3, maxLength: 98.4 },
      },
    },
  };

  var modelSelect = root.querySelector('#tosot-refrig-model');
  var lengthInput = root.querySelector('#tosot-refrig-length');
  var resultDiv = root.querySelector('#tosot-refrig-result');
  var noRefillDiv = root.querySelector('#tosot-refrig-no-refill');
  var errorDiv = root.querySelector('#tosot-refrig-error');
  var calculateBtn = root.querySelector('#tosot-refrig-calculate-btn');

  function updateLengthMax() {
    var seriesKey = seriesSelect.value;
    var modelKey = modelSelect.value;
    var model = fd[seriesKey].models[modelKey];
    if (model && model.maxLength) {
      lengthInput.max = model.maxLength;
    } else {
      lengthInput.removeAttribute('max');
    }
  }

  function updateModels() {
    var seriesKey = seriesSelect.value;
    var models = fd[seriesKey].models;
    modelSelect.innerHTML = '';
    for (var key in models) {
      var option = document.createElement('option');
      option.value = key;
      option.textContent = models[key].name;
      modelSelect.appendChild(option);
    }
    updateLengthMax();
    hideAllResults();
  }

  function hideAllResults() {
    resultDiv.style.display = 'none';
    noRefillDiv.style.display = 'none';
    errorDiv.style.display = 'none';
  }

  function calculate() {
    var refrigCopy = tosotGetPanelCopyConfig(root, 'refrig');
    var seriesKey = seriesSelect.value;
    var modelKey = modelSelect.value;
    var length = parseFloat(lengthInput.value);

    hideAllResults();

    if (isNaN(length) || length < 0) {
      errorDiv.textContent =
        refrigCopy.errorInvalidLength || 'Please enter a valid copper line length (0 or greater).';
      errorDiv.style.display = 'block';
      return;
    }

    var series = fd[seriesKey];
    var model = series.models[modelKey];

    if (length > model.maxLength) {
      var maxMsg =
        refrigCopy.errorMaxLength ||
        'Warning: Exceeds maximum allowed length for this model ([max] ft).';
      errorDiv.textContent = maxMsg.replace('[max]', String(model.maxLength));
      errorDiv.style.display = 'block';
      return;
    }

    if (length <= 25) {
      noRefillDiv.style.display = 'block';
      if (!root.classList.contains('tosot-combined-wrapper--product-popup')) {
        noRefillDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      return;
    }

    var refillRate = model.refillRate;
    var excess = length - 25;
    var amount = excess * refillRate;

    root.querySelector('#tosot-refrig-refill-amount').textContent = amount.toFixed(2) + ' oz';
    root.querySelector('#tosot-refrig-excess-length').textContent = excess.toFixed(1) + ' ft';
    root.querySelector('#tosot-refrig-refill-rate').textContent = refillRate + ' oz/ft';
    root.querySelector('#tosot-refrig-refrigerant-type').textContent = series.refrigerantType;

    resultDiv.style.display = 'block';
    if (!root.classList.contains('tosot-combined-wrapper--product-popup')) {
      resultDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    var modal = root.closest('.product-calculator-popup-modal');
    if (modal && modal.hasAttribute('open')) {
      window.requestAnimationFrame(function () {
        tosotApplyCalculatorPopupLayout(modal);
      });
    }
  }

  seriesSelect.addEventListener('change', updateModels);
  modelSelect.addEventListener('change', function () {
    updateLengthMax();
    hideAllResults();
  });
  lengthInput.addEventListener('input', hideAllResults);
  calculateBtn.addEventListener('click', calculate);

  updateModels();
}

function tosotInitAllRefrigerantCalculators() {
  document.querySelectorAll('[data-tosot-calculator-root]').forEach(function (root) {
    tosotInitRefrigerantCalculator(root);
  });
}

function tosotPrefetchCalculatorNotice() {
  tosotPersistCalculatorLiveConfig();
  var urls = tosotGetCalculatorNoticeFetchUrls();
  if (!urls.sectionUrl && !urls.pageUrl) {
    tosotWarmAllCalculatorPopups();
    return;
  }

  tosotFetchFreshCalculatorNotice()
    .then(function (payload) {
      payload = tosotNormalizeCalculatorSectionPayload(payload);
      if (!payload.notices.btu && !payload.notices.refrig && !payload.sectionRoot) return;
      document.querySelectorAll('[data-product-calculator-popup]').forEach(function (contentInfo) {
        tosotSyncCalculatorSectionToPopup(contentInfo, payload);
      });
    })
    .finally(function () {
      tosotWarmAllCalculatorPopups();
    });
}

function tosotInitCalculatorProductUi() {
  tosotInitAllRefrigerantCalculators();
  tosotInitAllQuotingTools();
  tosotInitHvacProposalHashRouting();
  tosotBindCalculatorPopupModals();
  tosotPrefetchCalculatorNotice();
  window.setTimeout(tosotWarmAllCalculatorPopups, 0);
}

// ===== Tab 3: HVAC Proposal / Quoting Tool (TosotTool) =====
    window.TosotTool = window.TosotTool || {};

    // ============================================================
    // TOSOT Direct — Local Rule Engine (Shopify-Compatible)
    // Version: 1.0.0-shopify
    // Replaces: Anthropic Claude API (claude-sonnet-4-20250514)
    // All calculations are deterministic and work offline.
    // ============================================================

    // ── Product Catalog ──────────────────────────────────────────
    window.TosotTool.PRODUCTS = [
      { id:'ms9-120',      name:'9,000 BTU Mini-Split 120V (Cosmo)',                      btu:9000,  type:'mini-split',     voltage:120, sqft:450,  seer2:20.5, wifi:true,  tag:'tag-mini',    url:'https://tosotdirect.com/products/tosot-9-000-btu-ductless-mini-split-inverter-air-conditioner-system-heat-pump',        series:'Cosmo' },
      { id:'ms12-120',     name:'12,000 BTU Mini-Split 120V (Cosmo)',                     btu:12000, type:'mini-split',     voltage:120, sqft:750,  seer2:19,   wifi:true,  tag:'tag-mini',    url:'https://tosotdirect.com/products/tosot-12-000-btu-ductless-mini-split-inverter-air-conditioner-system-heat-pump-120v', series:'Cosmo' },
      { id:'aoraki12-120', name:'12,000 BTU Aoraki Mini-Split 120V (24.5 SEER2 + ERV)',  btu:12000, type:'mini-split',     voltage:120, sqft:750,  seer2:24.5, wifi:true,  tag:'tag-mini',    url:'https://tosotdirect.com/products/aoraki-24-5-seer2-12-000-btu-heat-pump-mini-split-ac-w-erv-system',                   series:'Aoraki' },
      { id:'ms9-230',      name:'9,000 BTU Mini-Split 230V (Cosmo)',                      btu:9000,  type:'mini-split',     voltage:230, sqft:450,  seer2:20.5, wifi:true,  tag:'tag-mini',    url:'https://tosotdirect.com/products/9-000-btu-ductless-mini-split-inverter-heat-pump-air-conditioner-230v',               series:'Cosmo' },
      { id:'ms12-230',     name:'12,000 BTU Mini-Split 230V (Cosmo)',                     btu:12000, type:'mini-split',     voltage:230, sqft:750,  seer2:19,   wifi:true,  tag:'tag-mini',    url:'https://tosotdirect.com/products/12-000-btu-ductless-mini-split-inverter-heat-pump-air-conditioner-230v',               series:'Cosmo' },
      { id:'ms18-230',     name:'18,000 BTU Mini-Split 230V (Cosmo)',                     btu:18000, type:'mini-split',     voltage:230, sqft:1200, seer2:20,   wifi:true,  tag:'tag-mini',    url:'https://tosotdirect.com/products/tosot-18-000-btu-ductless-mini-split-inverter-air-conditioner-system-heat-pump',        series:'Cosmo' },
      { id:'ms24-230',     name:'24,000 BTU Mini-Split 230V (Cosmo)',                     btu:24000, type:'mini-split',     voltage:230, sqft:1500, seer2:19,   wifi:true,  tag:'tag-mini',    url:'https://tosotdirect.com/products/24-000-btu-mini-split-heat-pump-air-conditioner-230v',                                   series:'Cosmo' },
      { id:'ms30-230',     name:'30,000 BTU Mini-Split 230V (Cosmo)',                     btu:30000, type:'mini-split',     voltage:230, sqft:1800, seer2:22,   wifi:true,  tag:'tag-mini',    url:'https://tosotdirect.com/products/30-000-btu-mini-split-heat-pump-air-conditioner-230v',                                   series:'Cosmo' },
      { id:'ms36-230',     name:'36,000 BTU Mini-Split 230V (Cosmo)',                     btu:36000, type:'mini-split',     voltage:230, sqft:2200, seer2:18,   wifi:true,  tag:'tag-mini',    url:'https://tosotdirect.com/products/36-000-btu-mini-split-ac',                                                                  series:'Cosmo' },
      { id:'aoraki12-230', name:'12,000 BTU Aoraki Mini-Split 230V (24.5 SEER2 + ERV)',  btu:12000, type:'mini-split',     voltage:230, sqft:750,  seer2:24.5, wifi:true,  tag:'tag-mini',    url:'https://tosotdirect.com/products/aoraki-24-seer-12000btu-mini-split-air-conditioner-with-mini-erv-system',                series:'Aoraki' },
      { id:'aoraki24-230', name:'24,000 BTU Aoraki Mini-Split 230V (23.5 SEER2 + ERV)',  btu:24000, type:'mini-split',     voltage:230, sqft:1500, seer2:23.5, wifi:true,  tag:'tag-mini',    url:'https://tosotdirect.com/products/aoraki-24-5-seer2-1224btu-heat-pump-mini-split-ac-w-erv-system',                         series:'Aoraki' },
      { id:'mz18-2z',  name:'18,000 BTU Dual-Zone Mini-Split (21 SEER2)',  btu:18000, type:'multi-zone', voltage:230, sqft:1100, seer2:21, wifi:true, tag:'tag-multi', url:'https://tosotdirect.com/products/18000-btu-dual-zone-mini-split-air-conditioner-heat-pump',     series:'Free Match', zones:2 },
      { id:'mz24-2z',  name:'24,000 BTU Dual-Zone Mini-Split (21 SEER2)',  btu:24000, type:'multi-zone', voltage:230, sqft:1500, seer2:21, wifi:true, tag:'tag-multi', url:'https://tosotdirect.com/products/24000-btu-dual-zone-mini-split-air-conditioner-heat-pump',     series:'Free Match', zones:2 },
      { id:'mz30-2z',  name:'30,000 BTU Dual-Zone Mini-Split (21 SEER2)',  btu:30000, type:'multi-zone', voltage:230, sqft:1900, seer2:21, wifi:true, tag:'tag-multi', url:'https://tosotdirect.com/products/30000-btu-dual-zone-mini-split-air-conditioner-heat-pump',     series:'Free Match', zones:2 },
      { id:'mz36-2z',  name:'36,000 BTU Dual-Zone Mini-Split (21 SEER2)',  btu:36000, type:'multi-zone', voltage:230, sqft:2200, seer2:21, wifi:true, tag:'tag-multi', url:'https://tosotdirect.com/products/36000-btu-dual-zone-mini-split-air-conditioner-heat-pump',     series:'Free Match', zones:2 },
      { id:'mz30-3z',  name:'30,000 BTU Tri-Zone Mini-Split (21 SEER2)',   btu:30000, type:'multi-zone', voltage:230, sqft:1950, seer2:21, wifi:true, tag:'tag-multi', url:'https://tosotdirect.com/products/30000-btu-tri-zone-mini-split-air-conditioner-heat-pump',      series:'Free Match', zones:3 },
      { id:'mz36-3z',  name:'36,000 BTU Tri-Zone Mini-Split (21 SEER2)',   btu:36000, type:'multi-zone', voltage:230, sqft:2200, seer2:21, wifi:true, tag:'tag-multi', url:'https://tosotdirect.com/products/36000-btu-tri-zone-mini-split-air-conditioner-heat-pump',      series:'Free Match', zones:3 },
      { id:'mz36-4z',  name:'36,000 BTU Quad-Zone Mini-Split (21 SEER2)',  btu:36000, type:'multi-zone', voltage:230, sqft:2200, seer2:21, wifi:true, tag:'tag-multi', url:'https://tosotdirect.com/products/36000-btu-quad-zone-mini-split-air-conditioner-heat-pump',     series:'Free Match', zones:4 },
      { id:'floor34', name:'34,000 BTU Floor Standing Mini-Split', btu:34000, type:'floor-standing', voltage:230, sqft:1800, seer2:18, wifi:true,  tag:'tag-ducted', url:'https://tosotdirect.com/products/36-000-btu-floor-standing-mini-split-air-conditioner', series:'Light Commercial' },
      { id:'cas34',   name:'34,000 BTU Ceiling Cassette Mini-Split', btu:34000, type:'cassette', voltage:230, sqft:1800, seer2:18, wifi:true,  tag:'tag-ducted', url:'https://tosotdirect.com/products/36-000-btu-ceiling-cassette-mini-split-air-conditioner', series:'Cassette' },
      { id:'duc34',   name:'34,000 BTU Ducted Mini-Split', btu:34000, type:'ducted', voltage:230, sqft:1800, seer2:20, wifi:false, tag:'tag-ducted', url:'https://tosotdirect.com/products/34-000-btu-ducted-mini-split-air-conditioner', series:'Cosmo Ducted' },
      { id:'win8',  name:'8,000 BTU Chalet Window AC',  btu:8000,  type:'window', voltage:120, sqft:300,  seer2:14, wifi:false, tag:'tag-window', url:'https://tosotdirect.com/products/chalet-8000-btu-window-air-conditioner',  series:'Chalet' },
      { id:'win10', name:'10,000 BTU Chalet Window AC', btu:10000, type:'window', voltage:120, sqft:400,  seer2:14, wifi:false, tag:'tag-window', url:'https://tosotdirect.com/products/chalet-10000-btu-window-air-conditioner', series:'Chalet' },
      { id:'deh20',  name:'20 Pint Dehumidifier (Energy Star)',        pint:20, type:'dehumidifier', sqft:1000, tag:'tag-dehumid', url:'https://tosotdirect.com/products/tosot-20-pint-dehumidifier',           series:'Standard' },
      { id:'deh35',  name:'35 Pint Dehumidifier (Energy Star)',        pint:35, type:'dehumidifier', sqft:1800, tag:'tag-dehumid', url:'https://tosotdirect.com/products/35-pint-dehumidifier',                 series:'Standard' },
      { id:'deh50',  name:'50 Pint Dehumidifier (Energy Star)',        pint:50, type:'dehumidifier', sqft:2500, tag:'tag-dehumid', url:'https://tosotdirect.com/products/50-pint-dehumidifier',                 series:'Standard' },
      { id:'deh50p', name:'50 Pint Dehumidifier w/ Internal Pump',    pint:50, type:'dehumidifier', sqft:2500, tag:'tag-dehumid', url:'https://tosotdirect.com/products/tosot-50-pint-dehumidifier-with-pump', series:'w/ Pump' },
    ];

    // ── BTU Rule Engine ──────────────────────────────────────────
    window.TosotTool.BTU_RULES = {
      single_family:   20,
      vacation_home:   20,
      apartment:       20,
      home_addition:   20,
      garage_workshop: 20,
      rv:              20,
      pool_heating:    20,
      office:          25,
      hotel:           20,
      retail:          35,
      multifamily:     20,
      school:          25,
      medical:         25,
      other:           25,
      warehouse:       15,
    };

    window.TosotTool.FLOOR_ADJUSTMENTS = {
      top:      1.10,
      basement: 0.90,
      ground:   1.00,
      other:    1.00,
    };

    /**
     * calculateBTU(room, projType, warehouseType)
     * Returns the required BTU for a single room entry.
     */
    window.TosotTool.calculateBTU = function(room, projType, warehouseType) {
      var type = projType || 'other';
      var baseBtuPerSqft;

      if (type === 'warehouse') {
        baseBtuPerSqft = (warehouseType === 'open') ? 25 : 15;
      } else {
        baseBtuPerSqft = window.TosotTool.BTU_RULES[type] || 20;
      }

      var floorKey = (room.floor || 'ground').toLowerCase();
      var floorMult = window.TosotTool.FLOOR_ADJUSTMENTS[floorKey] || 1.0;

      var btuPerUnit = Math.ceil(room.area * baseBtuPerSqft * floorMult);
      return {
        btuPerUnit:    btuPerUnit,
        btuTotal:      btuPerUnit * room.qty,
        baseBtuPerSqft: baseBtuPerSqft,
        floorMult:     floorMult,
        adjustment:    floorMult === 1.0 ? 'None' : (floorMult > 1 ? '+10% Top Floor' : '-10% Basement'),
      };
    };

    /**
     * selectProducts(roomData, projType, warehouseType, installPref, powerSupply, priorities)
     * Returns array of recommendation objects.
     */
    window.TosotTool.selectProducts = function(roomData, projType, warehouseType, installPref, powerSupply, priorities) {
      var recommendations = [];
      var isMultiZone = (installPref === 'wall_mount_multi');
      var wantDehumid = priorities.indexOf('dehumidification') >= 0;
      var preferHighEfficiency = priorities.indexOf('max_efficiency') >= 0 || priorities.indexOf('energy_star') >= 0;

      var voltPref = powerSupply === '120v' ? 120 : 230;

      if (isMultiZone) {
        var totalZones = roomData.reduce(function(s, r) { return s + r.qty; }, 0);
        var totalBtu   = 0;
        roomData.forEach(function(r) {
          var calc = window.TosotTool.calculateBTU(r, projType, warehouseType);
          totalBtu += calc.btuTotal;
        });

        var mzProducts = window.TosotTool.PRODUCTS.filter(function(p) {
          return p.type === 'multi-zone' && p.zones >= Math.min(totalZones, 4);
        });

        mzProducts.sort(function(a, b) {
          var aDiff = Math.abs(a.zones - totalZones);
          var bDiff = Math.abs(b.zones - totalZones);
          if (aDiff !== bDiff) return aDiff - bDiff;
          var aOk = a.btu >= totalBtu;
          var bOk = b.btu >= totalBtu;
          if (aOk && !bOk) return -1;
          if (!aOk && bOk) return 1;
          return Math.abs(a.btu - totalBtu) - Math.abs(b.btu - totalBtu);
        });

        var chosen = mzProducts[0];
        if (!chosen) {
          chosen = window.TosotTool.PRODUCTS.filter(function(p){ return p.type === 'multi-zone'; })
                                           .sort(function(a,b){ return b.btu - a.btu; })[0];
        }

        if (chosen) {
          var allRoomNames = roomData.map(function(r) {
            return r.qty > 1 ? r.name + ' (×' + r.qty + ')' : r.name;
          }).join(', ');
          recommendations.push({
            product:    chosen,
            qty:        1,
            assignedTo: allRoomNames,
            btuRequired: totalBtu,
            reason:     window.TosotTool.buildReason(chosen, totalBtu, totalZones + '-zone system covering all spaces'),
          });
        }
      } else {
        var productMap = {};

        roomData.forEach(function(room) {
          var calc = window.TosotTool.calculateBTU(room, projType, warehouseType);
          var btuNeeded = calc.btuPerUnit;

          var candidates = window.TosotTool.filterByInstallType(installPref, voltPref, powerSupply);

          var best = window.TosotTool.findBestBtuMatch(candidates, btuNeeded, preferHighEfficiency);
          if (!best) {
            candidates = window.TosotTool.PRODUCTS.filter(function(p) {
              return p.type === 'mini-split' && (powerSupply === 'unsure' || p.voltage === voltPref);
            });
            best = window.TosotTool.findBestBtuMatch(candidates, btuNeeded, preferHighEfficiency);
          }
          if (!best) {
            best = window.TosotTool.PRODUCTS.filter(function(p){ return p.type !== 'dehumidifier'; })
                                           .sort(function(a,b){ return b.btu - a.btu; })[0];
          }

          if (best) {
            var key = best.id;
            if (productMap[key]) {
              productMap[key].qty += room.qty;
              productMap[key].assignedTo += ', ' + room.name;
              productMap[key].btuRequired += calc.btuTotal;
            } else {
              productMap[key] = {
                product:    best,
                qty:        room.qty,
                assignedTo: room.name,
                btuRequired: calc.btuTotal,
                reason:     window.TosotTool.buildReason(best, btuNeeded, room.name),
              };
            }
          }
        });

        recommendations = Object.values(productMap);
      }

      var hasBasement = roomData.some(function(r){ return (r.floor||'').toLowerCase() === 'basement'; });
      if (wantDehumid || hasBasement) {
        var totalSqft = roomData.reduce(function(s,r){ return s + r.qty * r.area; }, 0);
        var dehProducts = window.TosotTool.PRODUCTS.filter(function(p){ return p.type === 'dehumidifier'; });
        dehProducts.sort(function(a,b){ return a.sqft - b.sqft; });
        var deh = dehProducts.find(function(p){ return p.sqft >= totalSqft; }) || dehProducts[dehProducts.length-1];
        if (deh) {
          var dehReason = hasBasement
            ? 'Basement spaces benefit from dehumidification to prevent moisture buildup.'
            : 'Recommended for humidity control based on your priority selection.';
          recommendations.push({
            product:    deh,
            qty:        1,
            assignedTo: hasBasement ? 'Basement areas' : 'Full project',
            btuRequired: 0,
            reason:     dehReason,
            isAddon:    true,
          });
        }
      }

      return recommendations;
    };

    /**
     * Filter products by installation type preference and voltage.
     */
    window.TosotTool.filterByInstallType = function(installPref, voltPref, powerSupply) {
      return window.TosotTool.PRODUCTS.filter(function(p) {
        if (p.type === 'dehumidifier') return false;
        if (p.voltage && powerSupply !== 'unsure' && p.voltage !== voltPref) return false;
        switch (installPref) {
          case 'window':           return p.type === 'window';
          case 'floor_standing':   return p.type === 'floor-standing';
          case 'ducted':           return p.type === 'ducted';
          case 'wall_mount_single':return p.type === 'mini-split' || p.type === 'cassette';
          case 'not_sure':
          default:
            return p.type === 'mini-split' || p.type === 'cassette' ||
                   p.type === 'floor-standing' || p.type === 'ducted' || p.type === 'window';
        }
      });
    };

    /**
     * Find the best BTU match from a candidate list.
     */
    window.TosotTool.findBestBtuMatch = function(candidates, btuNeeded, preferHighEfficiency) {
      if (!candidates.length) return null;

      var adequate = candidates.filter(function(p){ return p.btu >= btuNeeded; });
      var undersized = candidates.filter(function(p){ return p.btu < btuNeeded; });

      var pool = adequate.length ? adequate : undersized;

      pool.sort(function(a, b) {
        var aDiff = Math.abs(a.btu - btuNeeded);
        var bDiff = Math.abs(b.btu - btuNeeded);
        if (aDiff !== bDiff) return aDiff - bDiff;
        if (preferHighEfficiency) return (b.seer2 || 0) - (a.seer2 || 0);
        return 0;
      });

      return pool[0] || null;
    };

    /**
     * Build a deterministic reason string for a product recommendation.
     */
    window.TosotTool.buildReason = function(product, btuNeeded, spaceName) {
      var typeLabels = {
        'mini-split':     'ductless mini-split',
        'multi-zone':     'multi-zone system',
        'floor-standing': 'floor-standing console',
        'cassette':       'ceiling cassette',
        'ducted':         'ducted system',
        'window':         'window unit',
        'dehumidifier':   'dehumidifier',
      };
      var typeLabel = typeLabels[product.type] || product.type;
      var btuLabel  = product.btu ? product.btu.toLocaleString() + ' BTU' : (product.pint + ' pint/day');
      var seerLabel = product.seer2 ? ' at ' + product.seer2 + ' SEER2' : '';
      var wifiLabel = product.wifi ? ' with WiFi control' : '';

      if (product.type === 'dehumidifier') {
        return product.pint + '-pint capacity covers up to ' + product.sqft.toLocaleString() + ' sq ft. Energy Star certified for efficient moisture removal.';
      }
      if (product.type === 'multi-zone') {
        return product.zones + '-zone ' + typeLabel + ' providing ' + btuLabel + seerLabel + wifiLabel + '. Covers all zones with a single outdoor unit.';
      }
      var match = btuNeeded ? (product.btu >= btuNeeded ? 'Meets' : 'Closest available match for') : 'Suitable for';
      return match + ' the ' + Math.round(btuNeeded).toLocaleString() + ' BTU requirement for ' + spaceName + '. ' + btuLabel + seerLabel + wifiLabel + '.';
    };

    /**
     * buildProposal(projectInfo, roomData, recommendations)
     * Returns a structured proposal object.
     */
    window.TosotTool.buildProposal = function(projectInfo, roomData, recommendations) {
      var totalSqft = roomData.reduce(function(s,r){ return s + r.qty * r.area; }, 0);
      var totalZones = roomData.reduce(function(s,r){ return s + r.qty; }, 0);
      var totalBtu   = recommendations.filter(function(r){ return !r.isAddon; })
                                      .reduce(function(s,r){ return s + (r.btuRequired||0); }, 0);

      var typeLabels = {
        hotel:'Hotel/Motel', office:'Office Building', retail:'Retail/Restaurant',
        multifamily:'Multi-Family/Apartments', warehouse:'Warehouse/Industrial',
        school:'School/Gym', medical:'Medical/Clinic', other:'Commercial',
        single_family:'Single-Family Home', vacation_home:'Vacation Home',
        garage_workshop:'Garage/Workshop', pool_heating:'Pool Heating',
        rv:'RV/Mobile', home_addition:'Home Addition/ADU', apartment:'Apartment/Condo',
      };
      var installLabels = {
        wall_mount_single:'Wall Mount Mini Split — Single Zone',
        wall_mount_multi:'Wall Mount Mini Split — Multi Zones',
        floor_standing:'Floor Standing Console',
        ducted:'Ducted/Concealed',
        window:'Window Units',
        not_sure:'Best Fit Per Space',
      };
      var typeLabel    = typeLabels[projectInfo.type]    || projectInfo.type    || 'Commercial';
      var installLabel = installLabels[projectInfo.install] || projectInfo.install || '';
      var powerLabel   = projectInfo.power === '230v' ? '230V (Commercial)' :
                         projectInfo.power === '120v' ? '120V (Residential)' : 'Not Specified';

      var summaryText = 'This proposal covers ' + totalSqft.toLocaleString() + ' sq ft across ' +
        totalZones + ' zone(s) for a ' + typeLabel.toLowerCase() + ' project in ' +
        (projectInfo.location || 'your area') + '. ' +
        'Total estimated cooling/heating load is ' + totalBtu.toLocaleString() + ' BTU. ' +
        recommendations.filter(function(r){ return !r.isAddon; }).length + ' product line(s) recommended.';

      var highlights = [
        'Total area: ' + totalSqft.toLocaleString() + ' sq ft',
        'Total zones: ' + totalZones,
        'Total BTU load: ' + totalBtu.toLocaleString(),
        'Installation type: ' + (installLabel || 'Best fit'),
        'Power supply: ' + powerLabel,
        'Products recommended: ' + recommendations.length,
      ];

      return {
        projectInfo:     projectInfo,
        roomData:        roomData,
        recommendations: recommendations,
        totalSqft:       totalSqft,
        totalZones:      totalZones,
        totalBtu:        totalBtu,
        typeLabel:       typeLabel,
        installLabel:    installLabel,
        powerLabel:      powerLabel,
        summaryText:     summaryText,
        highlights:      highlights,
        generatedAt:     new Date().toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' }),
      };
    };

    /**
     * renderProposal(proposal)
     * Updates the DOM with the proposal data.
     */
    window.TosotTool.renderProposal = function(proposal) {
      var pi = proposal.projectInfo;

      document.getElementById('resultTitle').textContent =
        (pi.title || 'HVAC Project Proposal') + ' — ' + proposal.typeLabel;
      document.getElementById('resultSubtitle').textContent =
        'Prepared for ' + pi.displayName + ' | Generated ' + proposal.generatedAt;

      document.getElementById('metaType').textContent  = proposal.typeLabel;
      document.getElementById('metaArea').textContent  = proposal.totalSqft.toLocaleString() + ' sq ft';
      document.getElementById('metaZones').textContent = proposal.totalZones;
      document.getElementById('metaBtu').textContent   = proposal.totalBtu.toLocaleString() + ' BTU';

      var tbody = document.getElementById('btuTableBody');
      tbody.innerHTML = '';
      var grandTotal = 0;
      proposal.roomData.forEach(function(room) {
        var calc = window.TosotTool.calculateBTU(room, pi.type, pi.warehouseType);
        grandTotal += calc.btuTotal;
        var tr = document.createElement('tr');
        tr.innerHTML =
          '<td>' + window.TosotTool.escHtml(room.name) + '</td>' +
          '<td>' + room.qty + '</td>' +
          '<td>' + room.area.toLocaleString() + '</td>' +
          '<td style="text-transform:capitalize;">' + (room.floor || 'ground') + '</td>' +
          '<td>' + calc.baseBtuPerSqft + '</td>' +
          '<td>' + calc.adjustment + '</td>' +
          '<td><strong>' + calc.btuTotal.toLocaleString() + '</strong></td>';
        tbody.appendChild(tr);
      });
      var totalRow = document.createElement('tr');
      totalRow.innerHTML =
        '<td colspan="6" style="text-align:right;font-weight:700;">Total BTU Required</td>' +
        '<td><strong>' + grandTotal.toLocaleString() + ' BTU</strong></td>';
      tbody.appendChild(totalRow);

      var cardsDiv = document.getElementById('productCards');
      cardsDiv.innerHTML = '';
      proposal.recommendations.forEach(function(rec, i) {
        var p = rec.product;
        var specParts = [];
        if (p.btu)   specParts.push(p.btu.toLocaleString() + ' BTU');
        if (p.pint)  specParts.push(p.pint + ' pint/day');
        if (p.seer2) specParts.push(p.seer2 + ' SEER2');
        if (p.voltage) specParts.push(p.voltage + 'V');
        if (p.wifi !== undefined) specParts.push(p.wifi ? 'WiFi' : 'No WiFi');
        if (p.series) specParts.push(p.series + ' Series');

        var card = document.createElement('div');
        card.className = 'product-card';
        card.innerHTML =
          '<div class="product-num">' + (i+1) + '</div>' +
          '<div class="product-info">' +
            '<div class="product-name">' +
              window.TosotTool.escHtml(p.name) +
              '<span class="product-tag ' + (p.tag||'tag-mini') + '">' + window.TosotTool.formatTypeLabel(p.type) + '</span>' +
            '</div>' +
            '<div class="product-spec">' + specParts.join(' · ') + '</div>' +
            '<div class="product-reason">' + window.TosotTool.escHtml(rec.reason) + '</div>' +
            '<div class="product-actions">' +
              '<span class="qty-badge">Qty: ' + rec.qty + '</span>' +
              '<span class="price-hint">For: ' + window.TosotTool.escHtml(rec.assignedTo) + '</span>' +
              (p.url ? '<a class="product-link" href="' + p.url + '" target="_blank" rel="noopener">View Product ↗</a>' : '') +
            '</div>' +
          '</div>';
        cardsDiv.appendChild(card);
      });

      var summaryBox = document.getElementById('summaryBox');
      document.getElementById('summaryText').textContent = proposal.summaryText;
      var ul = document.getElementById('summaryHighlights');
      ul.innerHTML = '';
      proposal.highlights.forEach(function(h) {
        var li = document.createElement('li');
        li.textContent = h;
        ul.appendChild(li);
      });
      summaryBox.style.display = 'block';

      document.getElementById('resultSection').classList.add('visible');
      document.getElementById('resultSection').scrollIntoView({ behavior: 'smooth', block: 'start' });

      for (var i = 0; i < 4; i++) {
        document.getElementById('pill' + i).className = 'step-pill done';
      }
      document.getElementById('pill3').className = 'step-pill active';
    };

    // ── Main Entry Point ─────────────────────────────────────────
    window.TosotTool.generateProposal = function() {
      var roomData = window.TosotTool.getRoomData();
      if (roomData.length === 0) {
        window.TosotTool.showError('Please add at least one space with area information.');
        return;
      }
      window.TosotTool.clearError();

      var btn = document.getElementById('generateBtn');
      btn.disabled = true;

      var projectInfo  = window.TosotTool.getProjectInfo();
      var priorities   = window.TosotTool.getSelectedPriorities();
      var installPref  = (document.getElementById('installPref') || {value:'not_sure'}).value || 'not_sure';
      var powerSupply  = (document.getElementById('powerSupply') || {value:'unsure'}).value  || 'unsure';
      var warehouseType = (document.getElementById('warehouseType') || {value:'na'}).value || 'na';

      var recommendations = window.TosotTool.selectProducts(roomData, projectInfo.type, warehouseType, installPref, powerSupply, priorities);

      if (!recommendations.length) {
        window.TosotTool.showError('No matching products found for the given criteria. Please adjust your preferences.');
        btn.disabled = false;
        return;
      }

      var proposal = window.TosotTool.buildProposal(projectInfo, roomData, recommendations);

      window.TosotTool.renderProposal(proposal);

      btn.disabled = false;
    };

    // ── UI Helpers ───────────────────────────────────────────────
    window.TosotTool.rooms = [];
    window.TosotTool.roomCounter = 0;
    window.TosotTool.selectedBuyerType = '';

    window.TosotTool.selectBuyerType = function(type, el) {
      window.TosotTool.selectedBuyerType = type;
      var tiles = document.querySelectorAll('#tosot-quoting-tool .buyer-tile');
      tiles.forEach(function(t){ t.classList.remove('selected'); });
      el.classList.add('selected');
      document.getElementById('step0NextBtn').disabled = false;

      var isConsumer = (type === 'Personal Residence');
      document.getElementById('consumerFields').style.display = isConsumer ? 'block' : 'none';
      document.getElementById('businessFields').style.display = isConsumer ? 'none' : 'block';
      window.TosotTool.updateProjectTypeOptions();
    };

    window.TosotTool.updateProjectTypeOptions = function() {
      var isConsumer = (window.TosotTool.selectedBuyerType === 'Personal Residence');
      var projTypeSelect = document.getElementById('projType');
      
      if (isConsumer && projTypeSelect) {
        var options = projTypeSelect.querySelectorAll('option');
        options.forEach(function(opt) {
          if (opt.value === 'pool_heating') {
            opt.style.display = 'none';
          } else {
            opt.style.display = '';
          }
        });
      }
    };

    window.TosotTool.togglePriority = function(el) {
      el.classList.toggle('selected');
    };

    window.TosotTool.getSelectedPriorities = function() {
      var chips = document.querySelectorAll('#tosot-quoting-tool .priority-chip.selected');
      return Array.from(chips).map(function(el){ return el.getAttribute('data-val'); });
    };

    window.TosotTool.goStep = function(n) {
      if (n === 2) {
        var isConsumer = (window.TosotTool.selectedBuyerType === 'Personal Residence');
        if (isConsumer) {
          var name = (document.getElementById('custName') || {value:''}).value.trim();
          var type = (document.getElementById('projType') || {value:''}).value;
          if (!name) { alert('Please enter your name.'); return; }
          if (!type) { alert('Please select a property type.'); return; }
        } else {
          var company = (document.getElementById('companyName') || {value:''}).value.trim();
          var btype   = (document.getElementById('projTypeBiz') || {value:''}).value;
          if (!company) { alert('Please enter your company name.'); return; }
          if (!btype)   { alert('Please select a building type.'); return; }
        }
      }

      for (var i = 0; i < 4; i++) {
        var sec = document.getElementById('step' + i);
        if (sec) sec.classList.remove('visible');
        var pill = document.getElementById('pill' + i);
        if (pill) pill.className = i < n ? 'step-pill done' : (i === n ? 'step-pill active' : 'step-pill');
      }
      var target = document.getElementById('step' + n);
      if (target) {
        target.classList.add('visible');
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    window.TosotTool.addRoom = function(defaults) {
      var d = defaults || {};
      window.TosotTool.roomCounter++;
      var id = window.TosotTool.roomCounter;
      var row = document.createElement('div');
      row.className = 'room-row';
      row.id = 'room-' + id;
      row.innerHTML =
        '<div class="field"><label>Space Name</label>' +
        '<input type="text" id="rname-' + id + '" value="' + window.TosotTool.escHtml(d.name||'') + '" placeholder="e.g. Living Room"></div>' +
        '<div class="field"><label>Qty (units)</label>' +
        '<input type="number" id="rqty-' + id + '" value="' + (d.qty||1) + '" min="1" max="50"></div>' +
        '<div class="field"><label>Area (sq ft)</label>' +
        '<input type="number" id="rarea-' + id + '" value="' + (d.area||'') + '" min="1" placeholder="500"></div>' +
        '<div class="field"><label>Floor</label>' +
        '<select id="rfloor-' + id + '">' +
        '<option value="ground"' + (d.floor==='ground'||!d.floor?' selected':'') + '>Ground</option>' +
        '<option value="top"'    + (d.floor==='top'   ?' selected':'') + '>Top Floor (+10%)</option>' +
        '<option value="basement"'+(d.floor==='basement'?' selected':'') + '>Basement (-10%)</option>' +
        '<option value="other"'  + (d.floor==='other' ?' selected':'') + '>Other</option>' +
        '</select></div>' +
        '<button class="del-btn" onclick="window.TosotTool.removeRoom(' + id + ')" title="Remove space">✕</button>';
      document.getElementById('roomList').appendChild(row);
      window.TosotTool.rooms.push(id);
    };

    window.TosotTool.removeRoom = function(id) {
      var el = document.getElementById('room-' + id);
      if (el) el.remove();
      window.TosotTool.rooms = window.TosotTool.rooms.filter(function(r){ return r !== id; });
    };

    window.TosotTool.getRoomData = function() {
      var data = [];
      window.TosotTool.rooms.forEach(function(id) {
        var el = document.getElementById('room-' + id);
        if (!el) return;
        var name  = (document.getElementById('rname-'  + id) || {value:''}).value.trim() || ('Space ' + id);
        var qty   = parseInt((document.getElementById('rqty-'  + id) || {value:'1'}).value) || 1;
        var area  = parseFloat((document.getElementById('rarea-' + id) || {value:'0'}).value) || 0;
        var floor = (document.getElementById('rfloor-' + id) || {value:'ground'}).value || 'ground';
        if (area > 0) data.push({ name, qty, area, floor });
      });
      return data;
    };

    window.TosotTool.getProjectInfo = function() {
      var isConsumer = (window.TosotTool.selectedBuyerType === 'Personal Residence');
      var displayName, email, type, location, title;

      if (isConsumer) {
        displayName = (document.getElementById('custName')  || {value:''}).value.trim() || 'Customer';
        email       = (document.getElementById('custEmail') || {value:''}).value.trim();
        type        = (document.getElementById('projType')  || {value:'single_family'}).value || 'single_family';
        location    = (document.getElementById('projLoc')   || {value:''}).value.trim();
        title       = (document.getElementById('projTitle') || {value:''}).value.trim();
      } else {
        displayName = (document.getElementById('companyName')   || {value:''}).value.trim() || 'Company';
        var contact = (document.getElementById('contactPerson') || {value:''}).value.trim();
        if (contact) displayName = displayName + ' (' + contact + ')';
        email       = (document.getElementById('bizEmail')      || {value:''}).value.trim();
        type        = (document.getElementById('projTypeBiz')   || {value:'office'}).value || 'office';
        location    = (document.getElementById('projLocBiz')    || {value:''}).value.trim();
        title       = (document.getElementById('projTitleBiz')  || {value:''}).value.trim();
      }

      return {
        displayName:   displayName,
        email:         email,
        buyerType:     window.TosotTool.selectedBuyerType || 'Other',
        type:          type,
        location:      location,
        title:         title,
        desc:          (document.getElementById('projDesc')    || {value:''}).value.trim(),
        power:         (document.getElementById('powerSupply') || {value:'unsure'}).value || 'unsure',
        install:       (document.getElementById('installPref') || {value:'not_sure'}).value || 'not_sure',
        budget:        (document.getElementById('budget')      || {value:''}).value || '',
        special:       (document.getElementById('specialReqs') || {value:''}).value.trim(),
        warehouseType: (document.getElementById('warehouseType') || {value:'na'}).value || 'na',
      };
    };

    // ── Copy Proposal ────────────────────────────────────────────
    window.TosotTool.buildProposalText = function() {
      var pi = window.TosotTool.getProjectInfo();
      var roomData = window.TosotTool.getRoomData();
      var priorities = window.TosotTool.getSelectedPriorities();
      var installPref = pi.install;
      var powerSupply = pi.power;
      var warehouseType = pi.warehouseType;

      var recommendations = window.TosotTool.selectProducts(roomData, pi.type, warehouseType, installPref, powerSupply, priorities);
      var proposal = window.TosotTool.buildProposal(pi, roomData, recommendations);

      var typeLabels = {
        hotel:'Hotel/Motel', office:'Office Building', retail:'Retail/Restaurant',
        multifamily:'Multi-Family/Apartments', warehouse:'Warehouse/Industrial',
        school:'School/Gym', medical:'Medical/Clinic', other:'Commercial',
        single_family:'Single-Family Home', vacation_home:'Vacation Home',
        garage_workshop:'Garage/Workshop', pool_heating:'Pool Heating',
        rv:'RV/Mobile', home_addition:'Home Addition/ADU', apartment:'Apartment/Condo',
      };
      var installLabels = {
        wall_mount_single:'Wall Mount Mini Split — Single Zone',
        wall_mount_multi:'Wall Mount Mini Split — Multi Zones',
        floor_standing:'Floor Standing Console',
        ducted:'Ducted/Concealed', window:'Window Units', not_sure:'Best Fit Per Space',
      };
      var priorityLabels = {
        ultra_quiet:'Ultra-Quiet Operation', max_efficiency:'Maximum Efficiency',
        budget_friendly:'Budget Friendly', wifi_smart:'WiFi / Smart Control',
        cold_climate:'Cold Climate Performance', easy_install:'Easy Installation',
        energy_star:'Energy Star Qualified', dehumidification:'Dehumidification',
      };

      var typeLabel    = typeLabels[pi.type]    || pi.type    || 'Commercial';
      var installLabel = installLabels[pi.install] || pi.install || '';
      var powerLabel   = pi.power === '230v' ? '230V (Commercial)' :
                         pi.power === '120v' ? '120V (Residential)' : 'Not Specified';
      var priorityText = priorities.length
        ? priorities.map(function(v){ return priorityLabels[v] || v; }).join(', ')
        : 'General comfort and efficiency';

      var totalSqft  = roomData.reduce(function(s,r){ return s + r.qty * r.area; }, 0);
      var totalZones = roomData.reduce(function(s,r){ return s + r.qty; }, 0);
      var totalUnits = recommendations.reduce(function(s,r){ return s + r.qty; }, 0);

      var isConsumerFlow = (pi.buyerType === 'Personal Residence');
      var tag = isConsumerFlow ? '[Residential Inquiry]' : (totalUnits > 3 ? '[Bulk Inquiry]' : '[Commercial Inquiry]');
      var subjectLine = tag + ' ' + (pi.title || 'HVAC Project') + ' | ' + totalSqft + ' sqft ' + typeLabel + ' — ' + pi.displayName;

      var SEP = '------------------------------------';
      var roomLines = '';
      roomData.forEach(function(r) {
        var calc = window.TosotTool.calculateBTU(r, pi.type, warehouseType);
        roomLines += '\n  - ' + r.name + ': ' + r.qty + ' unit(s) × ' + r.area + ' sq ft (' + r.floor + ' floor) = ' +
          (r.qty * r.area) + ' sq ft | BTU: ' + calc.btuTotal.toLocaleString();
      });

      var productLines = '';
      recommendations.forEach(function(rec, i) {
        var p = rec.product;
        var spec = p.btu ? p.btu.toLocaleString() + ' BTU' : p.pint + ' pint/day';
        if (p.seer2) spec += ', ' + p.seer2 + ' SEER2';
        if (p.voltage) spec += ', ' + p.voltage + 'V';
        productLines += '\n  ' + (i+1) + '. ' + p.name;
        productLines += '\n     Quantity : ' + rec.qty + ' unit(s)';
        productLines += '\n     Specs    : ' + spec;
        productLines += '\n     For      : ' + rec.assignedTo;
        productLines += '\n     Summary  : ' + rec.reason;
        if (p.url) productLines += '\n     URL      : ' + p.url;
        productLines += '\n';
      });

      var lines = [
        'To: support@tosotdirect.com',
        'Subject: ' + subjectLine,
        '',
        'Hello TOSOT Direct Sales Team,',
        '',
        'I have generated the following HVAC project proposal using your online recommendation',
        'tool and would like to request a formal quote.',
        '',
        SEP,
        'CUSTOMER INFORMATION',
        SEP,
        'Name / Company   : ' + pi.displayName,
        'Email            : ' + (pi.email || 'Not provided'),
        'Buyer Type       : ' + pi.buyerType,
        '',
        SEP,
        'PROJECT DETAILS',
        SEP,
        'Project Title : ' + (pi.title || 'HVAC Project'),
        'Project Type  : ' + typeLabel,
        'Location      : ' + (pi.location || 'Not specified'),
        'Total Area    : ' + totalSqft.toLocaleString() + ' sq ft across ' + totalZones + ' zone(s)',
        'Total BTU     : ' + proposal.totalBtu.toLocaleString() + ' BTU',
      ];
      if (pi.desc) lines.push('Notes         : ' + pi.desc);
      lines.push('');
      lines.push('SPACE BREAKDOWN:' + roomLines);
      lines.push('');
      lines.push(SEP); lines.push('PREFERENCES'); lines.push(SEP);
      lines.push('Priority Features : ' + priorityText);
      lines.push('Power Supply      : ' + powerLabel);
      lines.push('Installation Type : ' + installLabel);
      lines.push('Budget Range      : ' + (pi.budget || 'Not specified'));
      lines.push('Special Requests  : ' + (pi.special || 'None'));
      lines.push('');
      lines.push(SEP);
      lines.push('RECOMMENDED SYSTEMS (' + recommendations.length + ' product line(s) — ' + totalUnits + ' total unit(s))');
      lines.push(SEP);
      lines.push(productLines);
      lines.push(SEP); lines.push('REQUESTED ACTION'); lines.push(SEP);
      lines.push('Please contact me regarding:');
      lines.push('  - Pricing for the recommended quantities above');
      lines.push('  - Current availability and lead times');
      lines.push('  - Shipping and freight options');
      lines.push('  - Certified installer referrals if available in my area');
      lines.push('');
      lines.push('Generated by: TOSOT Direct Local Rule Engine v1.0 — ' + new Date().toLocaleDateString('en-US'));
      lines.push('');
      lines.push('Thank you,');
      lines.push(pi.displayName);

      return { subject: subjectLine, body: lines.join('\n') };
    };

    window.TosotTool.copyProposalToClipboard = function() {
      var btn   = document.getElementById('copyProposalBtn');
      var toast = document.getElementById('copyToast');
      var result;
      try {
        result = window.TosotTool.buildProposalText();
      } catch(e) {
        alert('Could not build proposal: ' + e.message);
        return;
      }
      var fullText = result.body;
      document.getElementById('toastSubjectLine').textContent = 'Subject: ' + result.subject;

      function showSuccess() {
        btn.textContent = '✅ Copied!';
        btn.disabled = true;
        btn.style.background = 'var(--success)';
        toast.style.display = 'block';
        toast.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        setTimeout(function() {
          btn.textContent = '📋 Copy Proposal to Clipboard';
          btn.disabled = false;
          btn.style.background = 'var(--red)';
        }, 4000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(fullText).then(showSuccess).catch(function() {
          window.TosotTool.fallbackCopy(fullText, showSuccess);
        });
      } else {
        window.TosotTool.fallbackCopy(fullText, showSuccess);
      }
    };

    window.TosotTool.fallbackCopy = function(text, onSuccess) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.cssText = 'position:fixed;top:-999px;left:-999px;opacity:0;';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try {
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        if (ok) { onSuccess(); }
        else { alert('Copy failed. Please manually copy the proposal text.'); }
      } catch(e) {
        document.body.removeChild(ta);
        alert('Copy not supported on this browser. Please use a modern browser.');
      }
    };

    window.TosotTool.resetAll = function() {
      window.TosotTool.rooms = []; 
      window.TosotTool.roomCounter = 0;
      document.getElementById('roomList').innerHTML = '';
      document.getElementById('btuTableBody').innerHTML = '';
      document.getElementById('productCards').innerHTML = '';
      document.getElementById('resultSection').classList.remove('visible');
      document.getElementById('summaryBox').style.display = 'none';
      document.getElementById('generateBtn').disabled = false;
      document.getElementById('copyToast').style.display = 'none';
      window.TosotTool.clearError();
      var inputs = document.querySelectorAll('#tosot-quoting-tool input,#tosot-quoting-tool select,#tosot-quoting-tool textarea');
      inputs.forEach(function(el) {
        if (el.type !== 'file') el.value = '';
      });
      var tiles = document.querySelectorAll('#tosot-quoting-tool .buyer-tile');
      tiles.forEach(function(t){ t.classList.remove('selected'); });
      var chips = document.querySelectorAll('#tosot-quoting-tool .priority-chip');
      chips.forEach(function(c){ c.classList.remove('selected'); });
      window.TosotTool.selectedBuyerType = '';
      document.getElementById('step0NextBtn').disabled = true;
      document.getElementById('consumerFields').style.display = 'block';
      document.getElementById('businessFields').style.display = 'none';
      window.TosotTool.addRoom({ name: 'Main Space', qty: 1, area: 500, floor: 'ground' });
      window.TosotTool.goStep(0);
    };

    window.TosotTool.showError = function(msg) {
      var el = document.getElementById('errorBox');
      el.textContent = '⚠ ' + msg;
      el.classList.add('visible');
    };

    window.TosotTool.clearError = function() {
      document.getElementById('errorBox').classList.remove('visible');
    };

    window.TosotTool.escHtml = function(str) {
      return String(str||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    };

    window.TosotTool.formatTypeLabel = function(type) {
      var labels = {
        'mini-split':'Mini-Split', 'multi-zone':'Multi-Zone',
        'floor-standing':'Floor Standing', 'cassette':'Cassette',
        'ducted':'Ducted', 'window':'Window', 'dehumidifier':'Dehumidifier',
      };
      return labels[type] || type;
    };
function tosotInitQuotingTool(root) {
  var scope = root || document;
  var tool = scope.querySelector('#tosot-quoting-tool');
  if (!tool || tool.dataset.quotingInit === 'true') return;
  tool.dataset.quotingInit = 'true';
  if (window.TosotTool && typeof window.TosotTool.addRoom === 'function') {
    window.TosotTool.addRoom({ name: 'Main Space', qty: 1, area: 500, floor: 'ground' });
  }
}

function tosotInitAllQuotingTools() {
  document.querySelectorAll('[data-tosot-calculator-root]').forEach(function (root) {
    tosotInitQuotingTool(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tosotInitCalculatorProductUi);
} else {
  tosotInitCalculatorProductUi();
}
